/* gm-brand.js · generated by tools/build-shopify.mjs from web/gm-wordmark.js, web/gm-cutsheet.js, web/gm-headercut.js, web/gm-cutlist.js, web/gm-catalog.js, web/gm-cutlist-store.js, web/gm-lead.js, web/gm-buy.js, web/gm-cutlist-page.js, web/gm-drawer.js. Do not edit. */
const __gm_wordmark = (() => {
/* gm-wordmark.js · Gunter Metals LLC extruded wordmark
 *
 * The Figma frames (ScrollTop / MidScroll / ScrollBottom) are one drawing:
 * 15 letter outlines stacked as two blurred shadows, eight extrusion slices
 * and a lit face. Between frames only the offsets and the face gradient
 * change. So this ships the outlines once and rebuilds the stack in the
 * browser, blending the frames continuously as you scroll, and adds a real
 * vanishing point so the letters splay the way a sign in space does.
 *
 *   <script type="module" src="/gm-wordmark.js"></script>
 *   <gm-wordmark scroll="exit" finish="powder-black">
 *     <img src="/gm-wordmark-static-powder-black.svg" alt="Gunter Metals LLC" width="448" height="315">
 *   </gm-wordmark>
 *
 * The <img> is the no-JS fallback; it is replaced once the element upgrades.
 *
 * Attributes
 *   scroll       "cover" (default)  0 as the element enters at the bottom of
 *                                   the viewport, 1 as it leaves at the top
 *                "exit"             0 while its top sits at the viewport top,
 *                                   1 once it has scrolled away (use for heroes)
 *                "pin"              for a sticky wordmark inside a tall section:
 *                                   0 to 1 across the section's pinned distance
 *   track        CSS selector of the element to measure instead of this one
 *                (nearest matching ancestor first). Needed with "pin".
 *   progress     0..1  pin the pose and ignore scroll (drive it from GSAP, tests)
 *   finish       stainless (default) | powder-black | mill-steel | galvanized
 *   perspective  0..0.2  how hard the letters converge on the vanishing point.
 *                Default 0.03. 0 reproduces the Figma frames exactly.
 *   sheen        multiplier on how far the highlight travels. Default 1; 0 = static.
 *   label        accessible name. Default "Gunter Metals LLC".
 *
 * Regenerate the data block from new Figma exports: node tools/build-wordmark.mjs
 */

const DATA = /* <data> */{"viewBox":[448,315],"glyphs":["M16.03 37.83C16.03 51.08 25.24 60.58 37.44 60.58C41.66 60.58 44.73 59.81 47.8 58.37V34.66H62.1V67.59C55.19 72.01 47.32 74.89 37.24 74.89C17.37 74.89 0.19 60.39 0.19 37.54C0.19 14.69 17.37 0 37.34 0C45.98 0 53.47 2.21 59.22 5.47V20.93C52.99 16.51 45.79 14.69 39.16 14.69C25.44 14.69 16.03 24.58 16.03 37.83Z","M103.51 74.89C85.17 74.89 74.04 62.6 74.04 45.03V1.63H89.68V45.12C89.68 54.92 94.87 60.58 103.51 60.58C112.34 60.58 117.81 54.92 117.81 45.03V1.63H133.55V45.03C133.55 62.6 122.03 74.89 103.51 74.89Z","M209.93 1.63V73.25H195.14L163.28 26.5H163.18V73.25H148.21V1.63H163.37L194.95 47.62H195.05V1.63H209.93Z","M240.61 73.25V15.94H219.59V1.63H277.09V15.94H256.16V73.25H240.61Z","M286.75 73.25V1.63H331.67V15.75H302.4V30.63H329.18V43.59H302.4V59.24H331.67V73.25H286.75Z","M344.96 73.25V1.63H367.62C384.89 1.63 395.64 9.98 395.64 24.96C395.64 33.51 391.13 43.2 377.5 46.76L399.1 73.25H380.29L361.28 48.1H360.61V73.25H344.96ZM360.61 36H366.94C375.39 36 379.9 32.26 379.9 25.92C379.9 19.39 375.01 15.94 367.23 15.94H360.61V36Z","M21.12 119.34L14.88 169.26H0L10.27 97.64H28.8L43.87 145.55H44.06L58.84 97.64H76.89L87.16 169.26H72.18L66.14 119.15H65.75L50.2 169.26H36.86L21.41 119.34H21.12Z","M98.62 169.26V97.64H143.54V111.75H114.26V126.63H141.04V139.59H114.26V155.24H143.54V169.26H98.62Z","M172 169.26V111.94H150.97V97.64H208.47V111.94H187.55V169.26H172Z","M275.14 169.26H258.73L252.39 151.79H225.61L219.47 169.26H203.15L229.93 97.64H247.98L275.14 169.26ZM229.93 138.92H247.98L238.95 113.96L229.93 138.92Z","M283.1 169.26V97.64H298.74V155.05H328.4V169.26H283.1Z","M360.59 96.1C367.88 96.1 374.41 98.22 379.21 101V115.4C374.51 112.04 367.4 109.93 361.45 109.93C355.12 109.93 350.7 112.42 350.7 116.94C350.7 121.16 354.64 123.08 362.12 126.15C372.3 130.19 383.43 134.7 383.43 148.33C383.43 161.77 372.97 170.8 357.13 170.8C348.21 170.8 340.24 167.92 335.44 164.36V149.2C340.43 153.71 348.21 157.07 355.6 157.07C362.7 157.07 367.4 153.8 367.4 148.91C367.4 144.11 362.41 141.8 354.64 138.63C345.81 134.99 335.25 130.28 335.25 117.51C335.25 105.03 345.13 96.1 360.59 96.1Z","M4.22 265.27V193.65H19.87V251.06H49.53V265.27H4.22Z","M59.25 265.27V193.65H74.89V251.06H104.55V265.27H59.25Z","M163.97 261.91C158.78 264.69 152.54 266.9 144.29 266.9C124.42 266.9 107.43 252.02 107.43 229.46C107.43 206.9 124.42 192.01 144.29 192.01C152.54 192.01 158.88 194.22 163.97 196.91V212.46C158.21 208.62 153.02 206.51 145.92 206.51C133.73 206.51 123.27 215.54 123.27 229.46C123.27 243.28 133.73 252.5 145.92 252.5C153.02 252.5 158.21 250.1 163.97 246.16V261.91Z"],"center":[200,133.5],"faceSpan":266.9,"maxExtrude":10.77,"shadow":{"soft":{"blur":12,"opacity":0.2},"tight":{"blur":7,"opacity":0.45}},"slices":[["#4D4D52","#38383D","#2B2B30"],["#505055","#3C3C41","#2F2F34"],["#545459","#404045","#333338"],["#58585D","#444449","#37373C"],["#5C5C61","#47474D","#3B3B40"],["#606065","#4B4B50","#3E3E44"],["#636369","#4F4F54","#424247"],["#67676C","#535358","#46464B"]],"faceOffsets":[0,0.06,0.1,0.15,0.25,0.35,0.45,0.55,0.65,0.75,0.85,0.9,1],"sheen":{"line":[-71.27,47.66,104.92,311.12],"stops":[[0,"#FFFFFF",0],[0.42,"#FFFFFF",0],[0.48,"#FFFFFF",0.12],[0.54,"#FFFFFF",0],[1,"#FFFFFF",0]],"opacity":0.4},"keys":[{"face":[22.5,29],"extrude":[2.4,-8],"soft":[24,24],"tight":[25.5,19],"faceStops":["#7A808C","#7E848F","#818791","#858A94","#8D929C","#9499A3","#9DA2AC","#A6ABB5","#AFB4BD","#B8BDC4","#BFC4CB","#C2C7CF","#BDC2C9"]},{"face":[21,18],"extrude":[3.2,8],"soft":[24,24],"tight":[27,30],"faceStops":["#ADB3BA","#BDC2C7","#B3B8BE","#A6ABB3","#ADB2B9","#B3B8BF","#A6ABB4","#999EA8","#9398A2","#8C919C","#848993","#80858F","#737885"]},{"face":[22,16],"extrude":[4,10],"soft":[24,24],"tight":[26,32],"faceStops":["#C2C7CF","#C8CDD3","#CCD1D6","#C5CAD0","#B8BDC4","#AEB3BC","#A3A8B3","#979CA6","#8A8F99","#7D828D","#707580","#6B707B","#616670"]}]}/* </data> */;
const WORDMARK = DATA;   // shared with gm-cutsheet.js

const LABEL = 'Gunter Metals LLC';
const DEFAULT_PERSPECTIVE = 0.03;
const SHEEN_TRAVEL = 1.1;   // fraction of the sheen gradient's length covered across the scroll

/* Finishes re-map the frames' colours by brightness onto a new ramp (dark to
   light), so the lighting still moves with scroll. `edge` is the strength of
   the 1 unit highlight on top edges; `grain` is the static SVG's texture. */
const FINISHES = {
  stainless: {
    sheen: 1, edge: 0.25,
    grain: { type: 'fractalNoise', freq: '0.003 1.6', octaves: 2, gain: 1.2, strength: 0.35 },
  },
  'powder-black': {
    face: ['#262a2f', '#41474e', '#858d96'], side: ['#0c0d0f', '#2c3035'],
    sheen: 0.6, edge: 0.45,
    grain: { type: 'fractalNoise', freq: '0.55', octaves: 2, gain: 1.6, strength: 0.3 },
  },
  'mill-steel': {
    face: ['#30363d', '#566270', '#9ea8b1'], side: ['#171b1f', '#3c444d'],
    sheen: 0.8, edge: 0.3,
    grain: { type: 'fractalNoise', freq: '0.009 0.022', octaves: 4, gain: 2.4, strength: 0.5 },
  },
  galvanized: {
    face: ['#7f878b', '#b9c0c3', '#e3e7e8'], side: ['#464c50', '#80878b'],
    sheen: 1.2, edge: 0.3,
    grain: { type: 'fractalNoise', freq: '0.05', octaves: 2, gain: 1.4, strength: 0.4, table: '0.36 0.64 0.45 0.58 0.4 0.66 0.5' },
  },
};
const FINISH_NAMES = Object.keys(FINISHES);

const [W, H] = DATA.viewBox;
const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
const f2 = n => Math.round(n * 100) / 100;
const f4 = n => Math.round(n * 10000) / 10000;
const rgb = c => [1, 3, 5].map(i => parseInt(c.slice(i, i + 2), 16));
const hex = v => '#' + v.map(x => clamp(Math.round(x), 0, 255).toString(16).padStart(2, '0')).join('');
const esc = s => String(s).replace(/[&<>"]/g, c => `&#${c.charCodeAt(0)};`);
const lum = c => 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];

function ramp(stops, t) {
  const L = stops.length - 1;
  const x = clamp(t, 0, 1) * L;
  const i = Math.min(Math.floor(x), L - 1), u = x - i;
  return stops[i].map((v, ch) => v + (stops[i + 1][ch] - v) * u);
}

const KEY_STOPS = DATA.keys.map(k => k.faceStops.map(rgb));
const SLICE_RGB = DATA.slices.map(stops => stops.map(rgb));
const GLYPHS = DATA.glyphs.map(d => `<path d="${d}"/>`).join('');
const lumRange = list => { const l = list.map(lum); return [Math.min(...l), Math.max(...l)]; };
const FACE_LUM = lumRange(KEY_STOPS.flat());
const SIDE_LUM = lumRange(SLICE_RGB.flat());

for (const f of Object.values(FINISHES)) {
  if (f.face) f.faceRGB = f.face.map(rgb);
  if (f.side) f.sideRGB = f.side.map(rgb);
}
const finishOf = name => FINISHES[name] || FINISHES.stainless;

function tone(c, f, part) {
  const stops = f[part + 'RGB'];
  if (!stops) return c;
  const [lo, hi] = part === 'face' ? FACE_LUM : SIDE_LUM;
  return ramp(stops, (lum(c) - lo) / (hi - lo));
}

// Uniform Catmull-Rom through evenly spaced keys. Keeps the motion smooth
// through the middle frame instead of kinking there.
function spline(values, p) {
  const last = values.length - 1;
  const x = clamp(p, 0, 1) * last;
  const i = Math.min(Math.floor(x), last - 1);
  const t = x - i;
  const p0 = values[Math.max(i - 1, 0)], p1 = values[i], p2 = values[i + 1], p3 = values[Math.min(i + 2, last)];
  return p1 + 0.5 * t * (p2 - p0 + t * (2 * p0 - 5 * p1 + 4 * p2 - p3 + t * (3 * (p1 - p2) + p3 - p0)));
}

function pose(p, finish = 'stainless') {
  const f = finishOf(finish);
  const ch = get => spline(DATA.keys.map(get), p);
  const pair = name => [ch(k => k[name][0]), ch(k => k[name][1])];
  return {
    p,
    face: pair('face'),
    extrude: pair('extrude'),
    soft: pair('soft'),
    tight: pair('tight'),
    faceStops: DATA.faceOffsets.map((_, s) => hex(tone([0, 1, 2].map(c => spline(KEY_STOPS.map(k => k[s][c]), p)), f, 'face'))),
  };
}

// Slice k of n sits k/n of the way back. Each is pushed along the extrusion
// vector and scaled toward the composition centre: P' = P·s + C·(1-s) + F + E·t
function sliceTransform(pz, k, n, perspective) {
  const t = k / n;
  const s = 1 - perspective * t;
  const [cx, cy] = DATA.center;
  const tx = cx * perspective * t + pz.face[0] + pz.extrude[0] * t;
  const ty = cy * perspective * t + pz.face[1] + pz.extrude[1] * t;
  return `matrix(${f4(s)} 0 0 ${f4(s)} ${f2(tx)} ${f2(ty)})`;
}

function sheenTransform(p, amount) {
  const [x1, y1, x2, y2] = DATA.sheen.line;
  const shift = (p - 0.5) * amount * SHEEN_TRAVEL;
  return `translate(${f2((x2 - x1) * shift)} ${f2((y2 - y1) * shift)})`;
}

// Shades for n slices, resampled from the frames' back-to-front ramp.
function sliceColors(n, f) {
  const L = SLICE_RGB.length - 1;
  return Array.from({ length: n }, (_, j) => {
    const u = n === 1 ? L : (j / (n - 1)) * L;
    const i = Math.min(Math.floor(u), L - 1), t = u - i;
    return SLICE_RGB[i].map((c, s) => hex(tone(c.map((v, ch) => v + (SLICE_RGB[i + 1][s][ch] - v) * t), f, 'side')));
  });
}

const blurFilter = (id, sd) =>
  `<filter id="${id}" x="-25%" y="-35%" width="150%" height="170%" color-interpolation-filters="sRGB"><feGaussianBlur stdDeviation="${sd}"/></filter>`;

// Figma's two inner shadows: a 1 unit highlight along top edges, a soft 2 unit shade along bottom edges.
const innerShadow = (id, edge) =>
  `<filter id="${id}" x="-5%" y="-5%" width="110%" height="110%" color-interpolation-filters="sRGB">` +
  `<feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="a"/>` +
  `<feOffset dy="-1"/><feGaussianBlur stdDeviation="0.5"/><feComposite in2="a" operator="arithmetic" k2="-1" k3="1"/>` +
  `<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 ${edge} 0"/><feBlend in2="SourceGraphic" result="hi"/>` +
  `<feOffset in="a" dy="2"/><feGaussianBlur stdDeviation="1"/><feComposite in2="a" operator="arithmetic" k2="-1" k3="1"/>` +
  `<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/><feBlend in2="hi"/></filter>`;

/* Surface texture for the static SVG: noise split into light and dark marks
   over the face. Plain alpha compositing, no blend modes, so OG and email
   rasterisers draw it too. Static only: re-filtering noise on every scroll
   frame costs more than it adds. */
function grainFilter(id, g) {
  const k = g.gain;
  return `<filter id="${id}" x="0" y="0" width="100%" height="100%" color-interpolation-filters="sRGB">` +
    `<feTurbulence type="${g.type}" baseFrequency="${g.freq}" numOctaves="${g.octaves}" seed="11" result="n"/>` +
    (g.table ? `<feComponentTransfer in="n" result="n"><feFuncR type="discrete" tableValues="${g.table}"/></feComponentTransfer>` : '') +
    `<feColorMatrix in="n" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 ${k} 0 0 0 ${f2(-(k * 0.5 + 0.02))}" result="hi"/>` +
    `<feColorMatrix in="n" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 ${-k} 0 0 0 ${f2(k * 0.5 - 0.04)}" result="lo"/>` +
    `<feMerge><feMergeNode in="lo"/><feMergeNode in="hi"/></feMerge>` +
    `<feComposite operator="in" in2="SourceAlpha"/></filter>`;
}

function mainMarkup(u, n, pz, o) {
  const f = finishOf(o.finish);
  const span = `x1="0" y1="0" x2="0" y2="${DATA.faceSpan}" gradientUnits="userSpaceOnUse"`;
  const [x1, y1, x2, y2] = DATA.sheen.line;
  const width = f2((1.15 * DATA.maxExtrude) / n);   // a touch wider than one step, so slices fuse into a solid side

  let defs = `<g id="${u}g">${GLYPHS}</g>`;
  sliceColors(n, f).forEach((stops, j) => {
    defs += `<linearGradient id="${u}s${j}" ${span}>` +
      stops.map((c, i) => `<stop offset="${f2(i / (stops.length - 1))}" stop-color="${c}"/>`).join('') +
      `</linearGradient>`;
  });
  defs += `<linearGradient id="${u}f" ${span}>` +
    DATA.faceOffsets.map((off, i) => `<stop offset="${off}" stop-color="${pz.faceStops[i]}"/>`).join('') +
    `</linearGradient>`;
  defs += `<linearGradient id="${u}h" x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" gradientUnits="userSpaceOnUse" gradientTransform="${sheenTransform(pz.p, o.sheen)}">` +
    DATA.sheen.stops.map(([off, c, a]) => `<stop offset="${off}" stop-color="${c}" stop-opacity="${a}"/>`).join('') +
    `</linearGradient>`;
  defs += innerShadow(`${u}ii`, f.edge);

  let slices = '';
  for (let j = 0; j < n; j++) {
    slices += `<use data-s href="#${u}g" fill="url(#${u}s${j})" stroke="url(#${u}s${j})" stroke-width="${width}" stroke-linejoin="round" transform="${sliceTransform(pz, n - j, n, o.perspective)}"/>`;
  }

  return `<defs>${defs}</defs><g>${slices}</g>` +
    `<g data-face filter="url(#${u}ii)" transform="translate(${f2(pz.face[0])} ${f2(pz.face[1])})">` +
    `<use href="#${u}g" fill="url(#${u}f)"/>` +
    `<use href="#${u}g" fill="url(#${u}h)" fill-opacity="${f2(DATA.sheen.opacity * f.sheen)}" style="mix-blend-mode:screen"/></g>`;
}

/* A single self-contained SVG of one pose, for the no-JS fallback, OG images, email.
   grain: strength of the finish's surface texture, 0 to turn it off. */
function staticSVG({ progress = 0.5, perspective = DEFAULT_PERSPECTIVE, sheen = 1, finish = 'stainless', grain, label = LABEL, slices = 24 } = {}) {
  const u = 'gm-';
  const f = finishOf(finish);
  const pz = pose(progress, finish);
  const strength = grain ?? f.grain.strength;
  const shadow = name =>
    `<g filter="url(#${u}${name})" fill="#000" fill-opacity="${DATA.shadow[name].opacity}" transform="translate(${f2(pz[name][0])} ${f2(pz[name][1])})"><use href="#${u}g"/></g>`;
  let filters = blurFilter(`${u}soft`, DATA.shadow.soft.blur) + blurFilter(`${u}tight`, DATA.shadow.tight.blur);
  let art = mainMarkup(u, slices, pz, { perspective, sheen, finish });
  if (strength > 0) {
    filters += grainFilter(`${u}grain`, f.grain);
    art = art.replace(/<\/g>$/, `<use href="#${u}g" fill="#000" filter="url(#${u}grain)" opacity="${f2(Math.min(strength, 1))}"/></g>`);
  }
  const body = art
    .replace('<defs>', `<defs>${filters}`)
    .replace('</defs>', `</defs>${shadow('soft')}${shadow('tight')}`)
    .replace(/ data-[a-z]+/g, '')
    .replace(/ href="/g, ' xlink:href="');
  return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 ${W} ${H}" width="${W}" height="${H}" role="img" aria-labelledby="${u}t"><title id="${u}t">${esc(label)}</title>${body}</svg>\n`;
}

/* ------------------------------ element ------------------------------ */

const CSS =
  `gm-wordmark{display:block;position:relative;aspect-ratio:${W}/${H}}` +
  `gm-wordmark>.gmw{position:absolute;inset:0;pointer-events:none}` +
  `gm-wordmark>.gmw>svg{display:block;width:100%;height:100%;overflow:visible}` +
  `gm-wordmark>.gmw-sh{will-change:transform}`;

const reduceMotion = typeof matchMedia === 'function' ? matchMedia('(prefers-reduced-motion: reduce)') : null;
let instances = 0;

if (typeof HTMLElement !== 'undefined' && !customElements.get('gm-wordmark')) {
  customElements.define('gm-wordmark', class extends HTMLElement {
    static observedAttributes = ['progress', 'perspective', 'sheen', 'label', 'finish'];

    connectedCallback() {
      if (!document.getElementById('gmw-style')) {
        document.head.append(Object.assign(document.createElement('style'), { id: 'gmw-style', textContent: CSS }));
      }
      this.u ??= `gmw${++instances}-`;
      this.setAttribute('role', 'img');
      this.setAttribute('aria-label', this.getAttribute('label') || LABEL);

      const layer = (cls, inner) =>
        `<div class="gmw ${cls}" aria-hidden="true"><svg viewBox="0 0 ${W} ${H}" focusable="false">${inner}</svg></div>`;
      const shadow = name =>
        layer('gmw-sh', `<defs>${blurFilter(this.u + name, DATA.shadow[name].blur)}</defs>` +
          `<g filter="url(#${this.u}${name})" fill="#000" fill-opacity="${DATA.shadow[name].opacity}">${GLYPHS}</g>`);
      this.innerHTML = shadow('soft') + shadow('tight') + layer('', '');
      [this.softLayer, this.tightLayer, this.mainLayer] = this.children;
      this.main = this.mainLayer.firstChild;

      this.cur = this.target();
      this.build();

      this.onScroll = () => this.kick();
      addEventListener('scroll', this.onScroll, { passive: true, capture: true });   // capture: also hears pages that scroll an inner element (Shopify Horizon on desktop)
      addEventListener('resize', this.onScroll);
      reduceMotion?.addEventListener?.('change', this.onScroll);
      this.io = new IntersectionObserver(([e]) => { this.visible = e.isIntersecting; this.kick(); }, { rootMargin: '15% 0px' });
      this.io.observe(this);
      this.ro = new ResizeObserver(() => { if (this.sliceCount() !== this.n) this.build(); });
      this.ro.observe(this);
    }

    disconnectedCallback() {
      removeEventListener('scroll', this.onScroll, { capture: true });
      removeEventListener('resize', this.onScroll);
      reduceMotion?.removeEventListener?.('change', this.onScroll);
      this.io?.disconnect();
      this.ro?.disconnect();
      cancelAnimationFrame(this.raf);
      this.raf = 0;
    }

    attributeChangedCallback(name) {
      if (!this.main) return;
      if (name === 'label') this.setAttribute('aria-label', this.getAttribute('label') || LABEL);
      if (name === 'finish') this.build();
      else this.kick();
    }

    opts() {
      const num = (name, def) => {
        const v = parseFloat(this.getAttribute(name));
        return Number.isFinite(v) ? v : def;
      };
      const finish = this.getAttribute('finish');
      return {
        perspective: clamp(num('perspective', DEFAULT_PERSPECTIVE), 0, 0.2),
        sheen: num('sheen', 1),
        finish: FINISHES[finish] ? finish : 'stainless',
      };
    }

    // Enough slices that each step is at most ~1.5 device pixels at the rendered size,
    // capped at 24 so a large mark stays cheap to repaint; the slice stroke closes what is left.
    sliceCount() {
      const unitPx = (this.clientWidth / W) * (devicePixelRatio || 1);
      return clamp(Math.ceil((DATA.maxExtrude * unitPx) / 1.5), 8, 24);
    }

    build() {
      const o = this.opts();
      this.n = this.sliceCount();
      this.main.innerHTML = mainMarkup(this.u, this.n, pose(this.cur, o.finish), o);
      this.slices = [...this.main.querySelectorAll('[data-s]')];
      this.face = this.main.querySelector('[data-face]');
      this.stops = [...this.main.querySelectorAll(`#${this.u}f stop`)];
      this.sheen = this.main.querySelector(`#${this.u}h`);
      this.applied = null;
      this.apply(this.cur);
    }

    target() {
      const pinned = parseFloat(this.getAttribute('progress'));
      if (Number.isFinite(pinned)) return clamp(pinned, 0, 1);
      if (reduceMotion?.matches) return 0.5;
      const sel = this.getAttribute('track');
      const r = ((sel && (this.closest(sel) || document.querySelector(sel))) || this).getBoundingClientRect();
      const vh = innerHeight || 1;
      const mode = this.getAttribute('scroll');
      const p = mode === 'exit' ? -r.top / (r.height || 1)
        : mode === 'pin' ? -r.top / Math.max(1, r.height - vh)
        : (vh - r.top) / (vh + r.height);
      return clamp(p, 0, 1);
    }

    kick() {
      if (this.raf || this.visible === false) return;
      this.last = performance.now();
      this.raf = requestAnimationFrame(this.tick);
    }

    // Eases toward the scroll position so the metal feels heavy rather than glued to the wheel.
    tick = now => {
      this.raf = 0;
      const goal = this.target();
      const instant = this.hasAttribute('progress') || reduceMotion?.matches;
      const k = instant ? 1 : 1 - Math.exp(-Math.min(64, now - this.last) / 110);
      this.last = now;
      this.cur += (goal - this.cur) * k;
      if (Math.abs(goal - this.cur) < 5e-4) this.cur = goal;
      this.apply(this.cur);
      if (this.cur !== goal) this.raf = requestAnimationFrame(this.tick);
    };

    apply(p) {
      const o = this.opts();
      const key = `${p}|${o.perspective}|${o.sheen}|${o.finish}`;
      if (key === this.applied) return;
      this.applied = key;

      const pz = pose(p, o.finish);
      const n = this.n;
      this.slices.forEach((el, j) => el.setAttribute('transform', sliceTransform(pz, n - j, n, o.perspective)));
      this.face.setAttribute('transform', `translate(${f2(pz.face[0])} ${f2(pz.face[1])})`);
      pz.faceStops.forEach((c, i) => this.stops[i].setAttribute('stop-color', c));
      this.sheen.setAttribute('gradientTransform', sheenTransform(p, o.sheen));
      const shift = ([x, y]) => `translate3d(${f4((x / W) * 100)}%,${f4((y / H) * 100)}%,0)`;
      this.softLayer.style.transform = shift(pz.soft);
      this.tightLayer.style.transform = shift(pz.tight);
    }
  });
}

return { WORDMARK, FINISH_NAMES, pose, staticSVG };
})();
const __gm_cutsheet = (() => {
/* gm-cutsheet.js · Gunter Metals LLC, the wordmark cut from a sheet of steel
 *
 * The view opens on a sheet of steel. One quiet torch pass cuts the name out
 * of it; then the sheet is lifted off toward the viewer and carried up until
 * only its bottom edge shows, where it stays as the site's navigation bar.
 * The cut letters are left lying where they were cut on the light surface
 * beneath. Each counter (R, A) is held to the sheet by two bridges one plate
 * wide, through the stroke above and below it, placed as marked up. The torch
 * cuts along the bridges too, and they lift away with the sheet, leaving the
 * stencil breaks in the strokes.
 *
 *   <script type="module" src="/gm-cutsheet.js"></script>
 *
 *   Driven by scrolling through a tall section that pins the sheet:
 *   <nav id="site-nav" style="position:fixed;top:0;left:0;right:0;height:60px">…</nav>
 *   <section id="hero" style="height:420vh">
 *     <div style="position:sticky;top:0;height:100vh">
 *       <gm-cutsheet reveal="scroll" track="#hero" dock="#site-nav" style="position:absolute;inset:0"></gm-cutsheet>
 *     </div>
 *   </section>
 *
 *   Or playing once by itself: <gm-cutsheet reveal></gm-cutsheet>
 *
 * It fills whatever box you give it (the dock handoff assumes that box is the viewport). Attributes:
 *   reveal  "scroll": the reveal follows the scroll position through `track`,
 *                     and runs backwards when you scroll back up.
 *           "" / "auto": plays once, the first time it is on screen. Time only
 *                     advances on painted frames, so a tab opened in the
 *                     background waits instead of finishing unseen.
 *           Without it, or under prefers-reduced-motion, it shows the finished letters.
 *   track   CSS selector of the tall section whose scroll drives reveal="scroll".
 *   bar     "early": the dock bar shows from the start as its own strip of steel, and the
 *           sheet slides up under it, rather than the bar appearing only once docked.
 *   dock    CSS selector of a position:fixed bar at the top of the page, usually the
 *           site navigation. The sheet is carried up into it; the bar is dressed as the
 *           same steel and made visible once the reveal is done. Without it the sheet leaves the frame.
 *   pace    speed multiplier for reveal="auto", default 1 (0.5 is half speed).
 *   edge    "soft" (default) restrained cut edges, or "bright" for the original chrome rim.
 *   label   accessible name, default "Gunter Metals LLC".
 * data-state on the element: pending | cutting | lifting | done, for styling around it.
 * el.replay() replays an "auto" reveal, or scrolls back to the uncut sheet in "scroll" mode.
 *
 * Rendering budget: everything that moves is its own compositor layer from the start,
 * so a frame is transforms and opacity plus a small repaint where the torch is. Nothing
 * uses blend modes or per-element masks, and masks only the lift needs are built when
 * the page is idle.
 */

const { WORDMARK } = __gm_wordmark;

const LABEL = 'Gunter Metals LLC';
const GLYPHS = WORDMARK.glyphs;
const GW = WORDMARK.center[0] * 2;
const GH = WORDMARK.center[1] * 2;

const PLATE = 2.2;          // bridge width: at least one plate thickness (see bridge-study.jsx)
// Where each counter's bridges cross it, as a fraction of its width (from the markup:
// R toward the stem, A through the middle). Letters not listed default to the middle.
const BRIDGE_AT = { 5: 0.35, 9: 0.5 };
const CONTACT = [1.2, 1.8]; // a letter's shadow on the surface: plate thickness × light from the upper left
// How hard the cut edges catch the light. "soft" keeps the kerf dark and the lit sliver
// narrow, which reads as torch-cut plate; "bright" is the original chrome-rimmed look.
// [dark width, dark opacity, lit width, lit opacity] for the letters, then for the sheet.
const EDGES = {
  soft: { letter: [1, 0.85, 0.5, 0.2], sheet: [1.5, 0.8, 0.55, 0.22] },
  bright: { letter: [0.9, 0.8, 0.7, 0.45], sheet: [1.4, 0.75, 0.8, 0.5] },
};
// Timeline in ms (at pace 1 for "auto"; for "scroll" it only sets proportions).
// hold: the uncut sheet before the torch ("auto" only). pierce: the arc warming
// at a cut's start. cool: the arc dying away at its end before the torch moves
// on. beat: stillness before the lift.
const T = { hold: 800, pierce: 70, travel: 2200, cool: 60, beat: 550, lift: 2800 };
// A fresh cut edge cools through the temper colours: bright orange off the torch,
// then straw, bronze, purple and the blue a fabricator sees beside a weld, before it
// settles to mill grey. TEMPER is how long that takes, in the same ms as the timeline.
const TEMPER = 1100;
const HEAT = [[0, '#ff7a18'], [0.2, '#e8912f'], [0.4, '#a9662f'], [0.6, '#6d4f82'], [0.8, '#3f6d9e'], [1, '#55636e']];
const hexRGB = c => [1, 3, 5].map(i => parseInt(c.slice(i, i + 2), 16));
const HEAT_RGB = HEAT.map(([at, col]) => [at, hexRGB(col)]);
const temper = age => {   // shared with gm-headercut.js, so both cool through the same colours
  let i = 1;
  while (i < HEAT_RGB.length - 1 && age > HEAT_RGB[i][0]) i++;
  const [a0, c0] = HEAT_RGB[i - 1], [a1, c1] = HEAT_RGB[i];
  const u = (age - a0) / (a1 - a0);
  return '#' + c0.map((v, k) => Math.round(v + (c1[k] - v) * u).toString(16).padStart(2, '0')).join('');
};

// Glowing kerf behind the arc, coolest first: [length, width, colour, opacity]
const TAIL = [[12, 1.3, '#c2531a', 0.7], [6, 1.2, '#ffb45c', 1], [2.5, 1, '#fff4dc', 1]];

const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
const f2 = n => Math.round(n * 100) / 100;
const f4 = n => Math.round(n * 10000) / 10000;
const ease = u => 0.5 - Math.cos(Math.PI * clamp(u, 0, 1)) / 2;   // sine in-out: no sudden starts or stops
const whenIdle = fn => (window.requestIdleCallback ? requestIdleCallback(fn, { timeout: 1200 }) : setTimeout(fn, 250));

function bbox(d) {
  let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity, cmd = '', idx = 0, x = 0, y = 0;
  for (const tok of d.match(/[A-Za-z]|-?\d*\.?\d+(?:e-?\d+)?/g)) {
    if (/[A-Za-z]/.test(tok)) { cmd = tok; idx = 0; continue; }
    if (cmd === 'H') x = +tok;
    else if (cmd === 'V') y = +tok;
    else if (idx++ % 2 === 0) { x = +tok; continue; }
    else y = +tok;
    x0 = Math.min(x0, x); x1 = Math.max(x1, x); y0 = Math.min(y0, y); y1 = Math.max(y1, y);
  }
  return [x0, y0, x1, y1];
}

// Every closed contour of every letter; the largest in each letter is its outline.
const CONTOURS = GLYPHS.flatMap((d, g) => {
  const subs = d.match(/M[^M]+/g).map(s => {
    const box = bbox(s);
    return { g, d: s, box, area: (box[2] - box[0]) * (box[3] - box[1]) };
  });
  const outer = subs.reduce((a, b) => (b.area > a.area ? b : a));
  subs.forEach(s => { s.outer = s === outer; });
  return subs;
});

const NS = 'xmlns="http://www.w3.org/2000/svg"';
// Mask images cover the element with a rect in user units. It has to reach past the
// viewBox (preserveAspectRatio leaves bands on one axis) but stay a sane size: WebKit
// fails to rasterise a mask drawn around a 1e5-unit rect, which left iOS showing an
// unpierced sheet over the cut letters.
const bigRect = (vb, w, h, scale) => {
  const [vx, vy, vw, vh] = vb.split(' ').map(Number);
  const rw = Math.max(vw, w / scale) * 1.6, rh = Math.max(vh, h / scale) * 1.6;
  return `x="${f2(vx + vw / 2 - rw / 2)}" y="${f2(vy + vh / 2 - rh / 2)}" width="${f2(rw)}" height="${f2(rh)}"`;
};
const PATHS = GLYPHS.map(d => `<path d="${d}"/>`).join('');
const svgURL = s => `url("data:image/svg+xml,${encodeURIComponent(s)}")`;

// Bridges and the cutting order need the browser's geometry, so they are worked out on first use.
let BRIDGES, RECTS, NOT_BRIDGES, CUTS;
function prepare() {
  if (CUTS) return;
  const SVG = 'http://www.w3.org/2000/svg';
  const probe = document.createElementNS(SVG, 'svg');
  probe.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden;visibility:hidden');
  document.documentElement.append(probe);

  // From the middle of each counter, walk up and down across the stroke; a bridge
  // spans from the counter out past the stroke's far edge.
  BRIDGES = [];
  for (const c of CONTOURS.filter(c => !c.outer)) {
    const glyph = probe.appendChild(document.createElementNS(SVG, 'path'));
    glyph.setAttribute('d', GLYPHS[c.g]);
    const x = c.box[0] + (BRIDGE_AT[c.g] ?? 0.5) * (c.box[2] - c.box[0]);
    const cy = (c.box[1] + c.box[3]) / 2;
    const pt = probe.createSVGPoint();
    const solid = y => { pt.x = x; pt.y = y; return glyph.isPointInFill(pt); };
    const across = dir => {
      let y = cy;
      for (let n = 0; n < 4000 && !solid(y); n++) y += dir * 0.25;
      for (let n = 0; n < 4000 && solid(y); n++) y += dir * 0.25;
      return y + dir * 1.5;
    };
    const top = across(-1), bottom = across(1);
    BRIDGES.push({ g: c.g, x: x - PLATE / 2, y: top, w: PLATE, h: cy - top });
    BRIDGES.push({ g: c.g, x: x - PLATE / 2, y: cy, w: PLATE, h: bottom - cy });
  }
  probe.remove();
  RECTS = BRIDGES.map(b => `<rect x="${f2(b.x)}" y="${f2(b.y)}" width="${f2(b.w)}" height="${f2(b.h)}"/>`).join('');
  // Everywhere except the bridges, as one even-odd path, for clipping.
  NOT_BRIDGES = `M-1e5 -1e5H1e5V1e5H-1e5Z` + BRIDGES.map(b => `M${f2(b.x)} ${f2(b.y)}h${f2(b.w)}v${f2(b.h)}h${f2(-b.w)}Z`).join('');

  // Per letter, as a program would run it: counters first, then the cuts along each
  // bridge (both sides in one pass), then the outline that frees the part.
  CUTS = GLYPHS.flatMap((_, g) => [
    ...CONTOURS.filter(c => c.g === g && !c.outer).map(c => ({ g, d: c.d })),
    ...BRIDGES.filter(b => b.g === g).map(b => ({
      g, bridge: true,
      d: `M${f2(b.x)} ${f2(b.y)}V${f2(b.y + b.h)}M${f2(b.x + b.w)} ${f2(b.y)}V${f2(b.y + b.h)}`,
    })),
    ...CONTOURS.filter(c => c.g === g && c.outer).map(c => ({ g, d: c.d })),
  ]);
}

// Hot-rolled plate: long mill-scale streaks and soft blotches. Drawn once as a tiling
// image, so the reveal never re-runs the noise; kept to two cheap noise passes so it
// rasterises quickly on a phone. Frequencies are whole cycles per tile, so it wraps
// without a visible seam or grid.
const TILE = 800;
const GRAIN = svgURL(
  `<svg ${NS} width="${TILE}" height="${TILE}">` +
  `<filter id="m" x="0" y="0" width="100%" height="100%"><feTurbulence type="fractalNoise" baseFrequency="0.0025 0.04" numOctaves="3" seed="4" stitchTiles="stitch"/>` +
  `<feColorMatrix values="0 0 0 0 0.62 0 0 0 0 0.68 0 0 0 0 0.74 1.5 0 0 0 -0.74"/></filter>` +
  `<filter id="d" x="0" y="0" width="100%" height="100%"><feTurbulence type="fractalNoise" baseFrequency="0.00375 0.0125" numOctaves="2" seed="9" stitchTiles="stitch"/>` +
  `<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 -1.3 0 0 0 0.6"/></filter>` +
  `<rect width="100%" height="100%" filter="url(#m)" opacity="0.1"/>` +
  `<rect width="100%" height="100%" filter="url(#d)" opacity="0.18"/></svg>`);

// The steel, lit from the upper left. Letters, sheet and dock bar share it, so they
// read as one plate. Without the grain, this is also the page's pre-script first paint.
const STEEL =
  `radial-gradient(85% 70% at 16% 6%, rgba(214,226,238,.16), transparent 62%),` +
  `radial-gradient(140% 120% at 50% 40%, transparent 50%, rgba(0,0,0,.5)),` +
  `${GRAIN} 0 0/${TILE}px ${TILE}px,` +
  `linear-gradient(158deg, #383e45 0%, #2a2f35 45%, #202428 100%)`;

// The surface the sheet was lying on.
const SURFACE =
  `radial-gradient(90% 75% at 18% 8%, #f7f5f0, transparent 70%),` +
  `linear-gradient(160deg, #eeece7 0%, #e2dfd8 100%)`;

// The plate's thickness seen at its bottom edge.
const EDGE = `linear-gradient(#59616a, #1a1d20)`;
const MASKED = `-webkit-mask-size:100% 100%;mask-size:100% 100%;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat`;
const CSS =
  `gm-cutsheet{display:block;position:relative;overflow:hidden;background:${SURFACE}}` +
  `gm-cutsheet>div{position:absolute;inset:0;pointer-events:none}` +
  `gm-cutsheet>div>svg{position:absolute;inset:0;width:100%;height:100%;overflow:visible}` +
  `gm-cutsheet>.gmc-plate,gm-cutsheet>.gmc-letters,gm-cutsheet>.gmc-sheet{background:${STEEL}}` +
  `gm-cutsheet>.gmc-letters,gm-cutsheet>.gmc-sheet{${MASKED}}` +
  `gm-cutsheet>.gmc-cast>div{position:absolute;inset:0;background:#000;${MASKED}}` +
  `gm-cutsheet>.gmc-lip{top:100%;bottom:auto;height:28px;` +
  `background:linear-gradient(#59616a 0,#1a1d20 3px,rgba(0,0,0,.32) 3px,rgba(0,0,0,.1) 11px,transparent 28px)}` +
  // The dock bar: the bottom strip of the same sheet, with its edge and a little shadow
  `.gmc-dock{background:${STEEL};background-repeat:no-repeat,no-repeat,repeat,no-repeat;box-shadow:0 14px 24px -10px rgba(0,0,0,.4)}` +
  `.gmc-dock::after{content:"";position:absolute;left:0;right:0;bottom:-3px;height:3px;pointer-events:none;background:${EDGE}}`;

const reduceMotion = typeof matchMedia === 'function' ? matchMedia('(prefers-reduced-motion: reduce)') : null;
let instances = 0;

if (typeof HTMLElement !== 'undefined' && !customElements.get('gm-cutsheet')) {
  customElements.define('gm-cutsheet', class extends HTMLElement {
    connectedCallback() {
      prepare();
      if (!document.getElementById('gmc-style')) {
        document.head.append(Object.assign(document.createElement('style'), { id: 'gmc-style', textContent: CSS }));
      }
      const u = (this.u ??= `gmc${++instances}-`);
      this.setAttribute('role', 'img');
      this.setAttribute('aria-label', this.getAttribute('label') || LABEL);

      const edge = EDGES[this.getAttribute('edge')] || EDGES.soft;
      const svg = inner => `<svg preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">${inner}</svg>`;
      // Clip paths, not masks: pure geometry, no offscreen buffers.
      const noBridges = id => `<clipPath id="${id}" clipPathUnits="userSpaceOnUse"><path clip-rule="evenodd" d="${NOT_BRIDGES}"/></clipPath>`;
      const bridged = [...new Set(BRIDGES.map(b => b.g))];

      this.innerHTML =
        // Each letter's own small shadow on the surface
        `<div class="gmc-contact">${svg(
          `<defs>${noBridges(`${u}cb`)}<filter id="${u}c" x="-5%" y="-5%" width="115%" height="115%">` +
          `<feOffset dx="${CONTACT[0]}" dy="${CONTACT[1]}"/><feGaussianBlur stdDeviation="1.4"/></filter></defs>` +
          `<g filter="url(#${u}c)"><g clip-path="url(#${u}cb)" fill="#000" fill-opacity="0.35">${PATHS}</g></g>`)}</div>` +
        `<div class="gmc-letters"></div>` +
        // The plate's edge around each letter: a dark hairline, catching light where it faces up-left
        `<div class="gmc-edge">${svg(
          `<defs>${noBridges(`${u}eb`)}</defs><g clip-path="url(#${u}eb)" fill="none" stroke-linejoin="round">` +
          `<g stroke="#0e1012" stroke-width="${edge.letter[0]}" stroke-opacity="${edge.letter[1]}">${PATHS}</g>` +
          `<g stroke="#9aa1a9" stroke-width="${edge.letter[2]}" stroke-opacity="${edge.letter[3]}" transform="translate(0.35 0.45)">${PATHS}</g></g>`)}</div>` +
        // The sheet's shadow on the surface while it is lifted
        `<div class="gmc-cast"><div></div></div>` +
        // The whole uncut plate, hiding the letters until the sheet around them comes away
        `<div class="gmc-plate"></div>` +
        `<div class="gmc-lip"></div>` +
        `<div class="gmc-sheet"></div>` +
        // The sheet's own thickness around each opening, seen once it is off the surface
        `<div class="gmc-sheet-edge">${svg(
          `<defs>${noBridges(`${u}sb`)}</defs><g clip-path="url(#${u}sb)" fill="none" stroke-linejoin="round">` +
          `<g stroke="#070809" stroke-width="${edge.sheet[0]}" stroke-opacity="${edge.sheet[1]}">${PATHS}</g>` +
          `<g stroke="#aab1b8" stroke-width="${edge.sheet[2]}" stroke-opacity="${edge.sheet[3]}" transform="translate(-0.45 -0.6)">${PATHS}</g></g>`)}</div>` +
        `<div class="gmc-fx">${svg(
          `<defs>${noBridges(`${u}fb`)}` +
          bridged.map(g => `<clipPath id="${u}s${g}" clipPathUnits="userSpaceOnUse"><path d="${GLYPHS[g]}"/></clipPath>`).join('') +
          `<radialGradient id="${u}glow">` +
          `<stop offset="0" stop-color="#fff"/><stop offset="0.18" stop-color="#e4edff" stop-opacity="0.7"/>` +
          `<stop offset="0.5" stop-color="#9db8ff" stop-opacity="0.16"/><stop offset="1" stop-color="#9db8ff" stop-opacity="0"/></radialGradient></defs>` +
          `<g fill="none" stroke="#08090a" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round">` +
          // Contours stop at the bridges; a bridge's own cuts only exist where they cross the stroke.
          `<g clip-path="url(#${u}fb)">${CUTS.map((c, i) => c.bridge ? '' : `<path data-kerf="${i}" d="${c.d}"/>`).join('')}</g>` +
          bridged.map(g => `<g clip-path="url(#${u}s${g})">${CUTS.map((c, i) => c.bridge && c.g === g ? `<path data-kerf="${i}" d="${c.d}"/>` : '').join('')}</g>`).join('') +
          `</g><g fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.9">` +
          `<g clip-path="url(#${u}fb)">${CUTS.map((c, i) => c.bridge ? '' : `<path data-heat="${i}" d="${c.d}" opacity="0"/>`).join('')}</g>` +
          bridged.map(g => `<g clip-path="url(#${u}s${g})">${CUTS.map((c, i) => c.bridge && c.g === g ? `<path data-heat="${i}" d="${c.d}" opacity="0"/>` : '').join('')}</g>`).join('') +
          `</g><g fill="none" stroke-linecap="round" stroke-linejoin="round">` +
          TAIL.map(([, w, col, op]) => `<path data-tail stroke="${col}" stroke-width="${w}" stroke-opacity="${op}" opacity="0"/>`).join('') +
          `</g><circle data-glow r="1" fill="url(#${u}glow)" opacity="0"/>`)}</div>`;

      this.letters = this.querySelector('.gmc-letters');
      this.contact = this.querySelector('.gmc-contact');
      this.edge = this.querySelector('.gmc-edge');
      this.cast = this.querySelector('.gmc-cast');
      this.plate = this.querySelector('.gmc-plate');
      this.lip = this.querySelector('.gmc-lip');
      this.sheet = this.querySelector('.gmc-sheet');
      this.sheetEdge = this.querySelector('.gmc-sheet-edge');
      this.fx = this.querySelector('.gmc-fx');
      this.moving = [this.plate, this.sheet, this.lip, this.cast, this.edge, this.sheetEdge, this.fx];
      this.svgs = [...this.querySelectorAll('svg')];
      const dockSel = this.getAttribute('dock');
      this.dock = dockSel ? document.querySelector(dockSel) : null;
      this.dock?.classList.add('gmc-dock');
      this.barEarly = this.getAttribute('bar') === 'early' && Boolean(this.dock);
      this.layoutKey = '';
      this.masksReady = false;
      this.run = null;
      this.layout();

      const value = this.getAttribute('reveal');
      this.mode = value === 'scroll' ? 'scroll' : value !== null ? 'auto' : null;
      const animate = this.mode && !(this.mode === 'auto' && this.state === 'done') && !reduceMotion?.matches;
      this.setState(animate ? 'pending' : 'done');
      if (animate) whenIdle(() => this.buildMasks()); else this.buildMasks();
      this.reset(animate);

      this.onScroll = () => this.kick();
      this.onVisibility = () => {
        if (document.visibilityState !== 'visible') { cancelAnimationFrame(this.raf); this.raf = 0; return; }
        if (this.run) this.kick();
        else if (this.onScreen) this.start();
      };
      addEventListener('scroll', this.onScroll, { passive: true, capture: true });   // capture: also hears pages that scroll an inner element (Shopify Horizon on desktop)
      addEventListener('resize', this.onScroll);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.ro = new ResizeObserver(() => { this.layout(); if (this.run) this.run.shown = -1; this.kick(); });
      this.ro.observe(this);
      this.io = new IntersectionObserver(([e]) => {
        this.onScreen = e.intersectionRatio >= 0.35;
        if (this.onScreen && this.mode === 'auto') this.start();
      }, { threshold: [0, 0.35] });
      this.io.observe(this);
      if (animate && this.mode === 'scroll') this.start();
    }

    disconnectedCallback() {
      removeEventListener('scroll', this.onScroll, { capture: true });
      removeEventListener('resize', this.onScroll);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.ro?.disconnect();
      this.io?.disconnect();
      cancelAnimationFrame(this.raf);
      this.raf = 0;
      if (this.run) this.setState('pending');
      this.run = null;
    }

    setState(state) {
      if (this.state === state) return;
      this.state = state;
      this.dataset.state = state;
    }

    pace() {
      return clamp(parseFloat(this.getAttribute('pace')) || 1, 0.25, 3);
    }

    trackElement() {
      const sel = this.getAttribute('track');
      return (sel && (this.closest(sel) || document.querySelector(sel))) || this;
    }

    // Scroll progress through the track: 0 as it reaches the top of the view,
    // 1 once its pinned distance has been scrolled.
    progress() {
      const r = this.trackElement().getBoundingClientRect();
      return clamp(-r.top / Math.max(1, r.height - innerHeight), 0, 1);
    }

    layout() {
      const w = this.clientWidth || 1, h = this.clientHeight || 1;

      // The dock bar shows the bottom strip of a sheet this size, so its steel lines up with the sheet's.
      this.barH = this.dock ? this.dock.offsetHeight : 0;
      if (this.dock) {
        const shift = `0 ${this.barH - h}px`;
        this.dock.style.backgroundSize = `${w}px ${h}px, ${w}px ${h}px, ${TILE}px ${TILE}px, ${w}px ${h}px`;
        this.dock.style.backgroundPosition = [shift, shift, shift, shift].join(', ');
      }

      // The letters take at most a set share of the width and height; every layer
      // shares one viewBox with preserveAspectRatio "meet", so they line up exactly.
      const narrow = w < 640;
      const vw = GW / (narrow ? 0.84 : 0.6);
      const vh = GH / (narrow ? 0.46 : 0.56);
      this.scale = Math.min(w / vw, h / vh);   // screen pixels per letter unit
      this.vb = `${f2((GW - vw) / 2)} ${f2((GH - vh) / 2)} ${f2(vw)} ${f2(vh)}`;
      const key = `${this.vb}|${f2(this.scale)}|${w}x${h}`;
      if (key === this.layoutKey) return;
      this.layoutKey = key;
      this.svgs.forEach(s => s.setAttribute('viewBox', this.vb));
      if (this.masksReady) { this.masksReady = false; this.buildMasks(); }
    }

    // The sheet's openings, the letters, and the sheet's blurred shadow. None is on
    // screen before the lift, so they are built once the page is idle (or on demand).
    buildMasks() {
      if (this.masksReady || !this.letters) return;
      this.masksReady = true;
      const w = this.clientWidth || 1, h = this.clientHeight || 1;
      const { vb, scale } = this;
      // CSS masks read an image's alpha, so draw each shape through an SVG
      // luminance mask to turn black into real transparency.
      const big = bigRect(vb, w, h, scale);
      const img = (inner, filter = '') => svgURL(
        `<svg ${NS} viewBox="${vb}" preserveAspectRatio="xMidYMid meet">${filter}` +
        `<mask id="m" maskUnits="userSpaceOnUse" ${big}>${inner}</mask><rect ${big} fill="#fff" mask="url(#m)"/></svg>`);
      const holes = `<rect ${big} fill="#fff"/><g fill="#000">${PATHS}</g><g fill="#fff">${RECTS}</g>`;
      const seenW = w / scale + 80 / scale, seenH = h / scale + 80 / scale;   // all on screen, plus the blur's reach
      const blur =
        `<filter id="b" filterUnits="userSpaceOnUse" x="${f2((GW - seenW) / 2)}" y="${f2((GH - seenH) / 2)}" width="${f2(seenW)}" height="${f2(seenH)}">` +
        `<feGaussianBlur stdDeviation="${f2(14 / scale)}"/></filter>`;
      this.mask(this.sheet, img(holes));
      this.mask(this.cast.firstChild, img(`<g filter="url(#b)">${holes}</g>`, blur));
      // The cut letters, less the bridges that stay with the sheet
      this.mask(this.letters, img(`<g fill="#fff">${PATHS}</g><g fill="#000">${RECTS}</g>`));
    }

    mask(el, url) {
      el.style.webkitMaskImage = url;
      el.style.maskImage = url;
    }

    // Keep what moves on its own compositor layer for the whole reveal, so nothing is
    // promoted (or repainted underneath) mid-motion.
    promote(on) {
      for (const el of this.moving) el.style.willChange = on ? 'transform, opacity' : '';
    }

    // pending: one whole plate, nothing cut yet. Otherwise: the letters on the surface,
    // and the sheet already docked as the bar.
    reset(pending) {
      this.plate.style.visibility = pending ? '' : 'hidden';
      this.plate.style.opacity = '';
      this.contact.style.opacity = pending ? '0' : '';
      for (const el of [this.sheet, this.cast, this.lip, this.sheetEdge]) {
        el.style.display = pending ? '' : 'none';
        el.style.transform = '';
        el.style.visibility = '';
      }
      // Near-zero rather than zero, so these layers are painted ahead of the lift.
      this.cast.style.opacity = this.lip.style.opacity = this.sheetEdge.style.opacity = '0.001';
      this.edge.style.opacity = pending ? '0.001' : '';
      this.fx.style.display = 'none';
      this.fx.style.opacity = '';
      this.promote(false);
      if (this.dock) this.dock.style.visibility = pending && !this.barEarly ? 'hidden' : 'visible';
    }

    replay() {
      if (!this.letters || !this.mode || reduceMotion?.matches) return;
      if (this.mode === 'scroll') {
        this.trackElement().scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.run = null;
      this.setState('pending');
      this.reset(true);
      const r = this.getBoundingClientRect();
      const onScreen = Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0));
      if (onScreen >= 0.35 * Math.min(r.height, innerHeight)) this.start();
    }

    start() {
      if (this.state !== 'pending' || this.run) return;
      if (this.mode === 'auto' && document.visibilityState !== 'visible') return;
      this.fx.style.display = '';
      this.promote(true);

      const kerfs = [];
      for (const el of this.fx.querySelectorAll('[data-kerf]')) kerfs[+el.dataset.kerf] = el;
      const heats = [];
      for (const el of this.fx.querySelectorAll('[data-heat]')) heats[+el.dataset.heat] = el;
      const lens = kerfs.map(el => el.getTotalLength());
      const perUnit = T.travel / lens.reduce((a, b) => a + b, 0);
      let at = this.mode === 'scroll' ? 0 : T.hold;
      const plan = lens.map((len, i) => {
        const step = { start: at + T.pierce };
        step.end = step.start + len * perUnit;
        at = step.end + T.cool;   // let the arc die away before the torch moves on
        kerfs[i].setAttribute('stroke-dasharray', `${f2(len)} ${f2(len + 1)}`);
        kerfs[i].setAttribute('stroke-dashoffset', f2(len));
        if (heats[i]) {
          heats[i].setAttribute('stroke-dasharray', `${f2(len)} ${f2(len + 1)}`);
          heats[i].setAttribute('stroke-dashoffset', f2(len));
          heats[i].setAttribute('opacity', '0');
        }
        return step;
      });
      const liftAt = at - T.cool + T.beat;

      this.run = {
        clock: 0, last: performance.now(), cur: this.progress(),
        kerfs, heats, lens, plan, liftAt, total: liftAt + T.lift, glowState: [],
        tails: [...this.fx.querySelectorAll('[data-tail]')], glow: this.fx.querySelector('[data-glow]'),
        on: -1, dash: [], lifting: false, docked: false, shown: -1,
      };
      this.setState('cutting');
      this.kick();
    }

    kick() {
      if (!this.run || this.raf) return;
      this.run.last = performance.now();
      this.raf = requestAnimationFrame(this.frame);
    }

    frame = now => {
      this.raf = 0;
      const r = this.run;
      if (!r) return;
      const elapsed = Math.max(0, now - r.last);
      r.last = now;

      let t, moving;
      if (this.mode === 'scroll') {
        // The sheet has weight: it follows the scroll position, never snaps to it.
        // Exponential easing is stable at any frame length, so a busy machine lags less, not more.
        const goal = this.progress();
        r.cur += (goal - r.cur) * (1 - Math.exp(-Math.min(elapsed, 250) / 140));
        if (Math.abs(goal - r.cur) < 1e-4) r.cur = goal;
        // Finish a little before the end of the track: scroll position rarely lands on exactly 1,
        // and the sheet must reach the bar for the handoff to happen.
        t = clamp(r.cur / 0.97, 0, 1) * r.total;
        moving = r.cur !== goal;
      } else {
        r.clock += Math.min(elapsed, 50) * this.pace();   // a long frame stretches time rather than jumping
        t = r.clock;
        moving = t < r.total;
      }
      if (t !== r.shown) { r.shown = t; this.render(t); }

      if (this.mode === 'auto' && !moving) {
        this.run = null;
        this.setState('done');
        this.reset(false);
        return;
      }
      // Scroll mode keeps a frame in flight while the sheet is on screen. iOS coalesces
      // scroll events during momentum, and waiting for the next one froze the lift.
      if (moving || (this.mode === 'scroll' && this.onScreen)) this.raf = requestAnimationFrame(this.frame);
    };

    // Everything on screen is a function of t, so the reveal can run either way.
    render(t) {
      const r = this.run;
      if (!this.masksReady && t > r.liftAt * 0.4) this.buildMasks();   // someone is scrolling fast

      let arc = null;
      r.plan.forEach((step, i) => {
        const len = r.lens[i];
        const cut = clamp((t - step.start) / (step.end - step.start), 0, 1) * len;
        const off = String(f2(len - cut));
        if (r.dash[i] !== off) { r.dash[i] = off; r.kerfs[i].setAttribute('stroke-dashoffset', off); }
        // The same length of edge, cooling from where the torch left it.
        const hot = r.heats[i];
        if (hot) {
          const age = clamp((t - step.end) / TEMPER, 0, 1);
          const seen = cut > 0 ? f2(0.9 * (1 - age) ** 0.45) : 0;
          const was = r.glowState[i] || {};
          if (was.off !== off) hot.setAttribute('stroke-dashoffset', off);
          if (was.seen !== seen) hot.setAttribute('opacity', String(seen));
          const col = seen > 0 ? temper(age) : was.col;
          if (seen > 0 && was.col !== col) hot.setAttribute('stroke', col);
          r.glowState[i] = { off, seen, col };
        }
        const pierceAt = step.start - T.pierce;
        if (t >= pierceAt && t < step.end) arc = { i, cut, heat: ease((t - pierceAt) / T.pierce) };
        else if (t >= step.end && t < step.end + T.cool) arc = { i, cut: len, heat: 1 - ease((t - step.end) / T.cool) };
      });

      if (arc) {
        const path = r.kerfs[arc.i];
        const len = r.lens[arc.i];
        const pt = path.getPointAtLength(arc.cut);
        r.glow.setAttribute('transform', `translate(${f2(pt.x)} ${f2(pt.y)}) scale(${f2(9 * (0.4 + 0.6 * arc.heat))})`);
        r.glow.setAttribute('opacity', f2(arc.heat));
        if (r.on !== arc.i) {
          r.on = arc.i;
          r.tails.forEach(el => el.setAttribute('d', CUTS[arc.i].d));
        }
        TAIL.forEach(([L], k) => {
          const l = Math.min(arc.cut, L);
          const el = r.tails[k];
          el.setAttribute('stroke-dasharray', `${f2(l)} ${f2(len * 2)}`);
          el.setAttribute('stroke-dashoffset', f2(-(arc.cut - l)));
          el.setAttribute('opacity', l > 0 ? f2(arc.heat) : '0');
        });
      } else if (r.on !== -1) {
        r.on = -1;
        r.glow.setAttribute('opacity', '0');
        r.tails.forEach(el => el.setAttribute('opacity', '0'));
      }

      // Every part cut: the sheet comes away and the letters stay where they lie.
      const lifting = t >= r.liftAt;
      if (lifting !== r.lifting) {
        r.lifting = lifting;
        this.plate.style.visibility = '';
      }
      // At the end, exactly 1: (liftAt + lift - liftAt) / lift can round to just under it.
      const u = t >= r.total ? 1 : lifting ? clamp((t - r.liftAt) / T.lift, 0, 1) : 0;
      // One continuous motion: lifted off the surface, and overlapping that, carried up
      // and set down flat as the bar (or out of the frame when there is no bar).
      const rise = ease(u / 0.4);
      const away = ease((u - 0.25) / 0.75);
      this.setState(u >= 1 ? 'done' : lifting ? 'lifting' : 'cutting');

      const W = this.clientWidth, H = this.clientHeight;
      const travel = this.barH ? H - this.barH : 1.15 * H;
      const lift = -(0.015 * rise * (1 - away) * H + away * travel);
      const grow = 0.05 * rise * (1 - away);
      const style = (el, prop, value) => { if (el.style[prop] !== value) el.style[prop] = value; };
      const sheetTransform = lifting ? `translate3d(0,${f2(lift)}px,0) scale(${f4(1 + grow)})` : 'none';
      style(this.fx, 'opacity', String(f2(1 - ease(u / 0.2))));
      style(this.edge, 'opacity', String(Math.max(0.001, f2(rise))));   // the letters' edges show as the gap opens
      // The uncut plate is what the openings show while the sheet is still flush; it goes
      // as the sheet rises off it, so no frame shows through to the surface below.
      const covered = 1 - ease(rise / 0.12);
      style(this.plate, 'opacity', String(f2(covered)));
      style(this.plate, 'visibility', covered <= 0.002 ? 'hidden' : '');
      // Each letter only casts a shadow once there is a gap to cast it into.
      style(this.contact, 'opacity', String(f2(ease(rise / 0.5))));
      style(this.sheet, 'transform', sheetTransform);
      style(this.sheetEdge, 'transform', sheetTransform);
      style(this.sheetEdge, 'opacity', String(Math.max(0.001, f2(rise * (1 - away)))));
      // The plate's bottom edge and its shadow ride along with it.
      style(this.lip, 'transform', `translate3d(0,${f2(lift + (grow / 2) * H)}px,0)`);
      style(this.lip, 'opacity', String(Math.max(0.001, f2(rise))));
      // Its shadow on the surface opens down-right as the gap grows, then softens away as it is carried off.
      style(this.cast, 'transform', `translate3d(${f2(0.014 * rise * W)}px,${f2(0.022 * rise * H + lift)}px,0) scale(${f4(1 + 0.03 * rise)})`);
      style(this.cast, 'opacity', String(Math.max(0.001, f2(0.45 * rise * (1 - ease(away / 0.35))))));

      // Once set down, the bar takes over from the sheet so it can stay with the page.
      if (this.dock) {
        const docked = u >= 1;
        if (docked !== r.docked) {
          r.docked = docked;
          if (!this.barEarly) this.dock.style.visibility = docked ? 'visible' : 'hidden';
          for (const el of [this.sheet, this.lip, this.sheetEdge]) el.style.visibility = docked ? 'hidden' : '';
        }
      }
    }
  });
}

return { temper };
})();
const __gm_headercut = (() => {
// Home page only: the header bar is its own strip of steel from the first frame, and on
// arrival a torch cuts into it, without anyone scrolling: the icons first, then the G mark,
// then the menu words. Outlines are traced by a travelling arc; words are cut behind an arc
// that sweeps across them (they stay real text). Every fresh cut cools through the same
// temper colours as the wordmark (gm-cutsheet.js) before it settles to steel.
//
// The hours strip stays tucked behind the bar until the sheet has lifted and docked, then
// slides down from under the bar's edge; scrolling back up tucks it away again.
//
// Runs when the page has <gm-cutsheet dock bar="early">. [data-cut] marks the icons and the
// logo (data-cut="logo"; data-cut="burger" is the two-line menu button); the words are the
// header's menu links.

const { temper } = __gm_cutsheet;

const NS = 'http://www.w3.org/2000/svg';
// Fixed times per piece rather than one torch speed, so the whole bar is cut in about two seconds.
const START = 300;        // ms after the bar appears, so the eye finds it first
const ICON_MS = 200, LOGO_MS = 600, WORD_MS = 280, GAP = 60, TEMPER = 900, SETTLE = 300;
const HOT = '#ff7a18';
const BURGER = ['M3 9H21', 'M3 15H21'];

const reduce = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
const sheet = document.querySelector('gm-cutsheet[dock][bar="early"]');
const header = sheet && document.querySelector(sheet.getAttribute('dock'));

const clamp01 = (v) => Math.min(1, Math.max(0, v));

function glowGradient(id) {
  return `<defs><radialGradient id="${id}"><stop offset="0" stop-color="#fff"/><stop offset=".18" stop-color="#e4edff" stop-opacity=".7"/>` +
    `<stop offset=".5" stop-color="#9db8ff" stop-opacity=".16"/><stop offset="1" stop-color="#9db8ff" stop-opacity="0"/></radialGradient></defs>`;
}

function place(svg, box) {
  const bar = header.getBoundingClientRect();
  Object.assign(svg.style, { left: `${box.left - bar.left}px`, top: `${box.top - bar.top}px`, width: `${box.width}px`, height: `${box.height}px` });
}

// An icon or the logo: its own outlines, redrawn as kerf over the bar.
function outlineJob(target) {
  const burger = target.dataset.cut === 'burger';
  const src = target.querySelector('svg');
  if (!burger && !src) return null;
  const logo = target.dataset.cut === 'logo';
  const viewBox = burger ? '0 0 24 24' : src.getAttribute('viewBox') || '0 0 24 24';
  const svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('class', 'gm-cut-overlay');
  svg.setAttribute('viewBox', viewBox);
  svg.setAttribute('aria-hidden', 'true');
  place(svg, target.getBoundingClientRect());
  const glowId = `gmh-${Math.random().toString(36).slice(2, 7)}`;
  svg.innerHTML = glowGradient(glowId);
  const g = document.createElementNS(NS, 'g');
  g.setAttribute('fill', 'none');
  g.setAttribute('stroke-linecap', 'round');
  g.setAttribute('stroke-linejoin', 'round');
  svg.append(g);
  const cuts = (burger ? BURGER : [...src.querySelectorAll('path, circle, rect, line, polyline, polygon')]).map((s) => {
    let el;
    if (typeof s === 'string') { el = document.createElementNS(NS, 'path'); el.setAttribute('d', s); }
    else { el = s.cloneNode(false); for (const a of ['fill', 'filter', 'id', 'style', 'mask', 'clip-path']) el.removeAttribute(a); }
    el.setAttribute('stroke-width', logo ? 1.1 : 2);
    el.setAttribute('stroke', HOT);
    g.append(el);
    return el;
  });
  const glow = document.createElementNS(NS, 'circle');
  glow.setAttribute('r', String((+viewBox.split(/\s+/)[2] || 24) * 0.22));
  glow.setAttribute('fill', `url(#${glowId})`);
  glow.setAttribute('opacity', '0');
  svg.append(glow);
  header.append(svg);
  const lens = cuts.map((el) => el.getTotalLength());
  let from = 0;
  const spans = lens.map((len) => { const s = { from, to: from + len }; from += len; return s; });
  cuts.forEach((el, i) => { el.setAttribute('stroke-dasharray', `${lens[i]} ${lens[i] + 1}`); el.setAttribute('stroke-dashoffset', String(lens[i])); });
  const total = from;
  return {
    target, svg, ms: logo ? LOGO_MS : ICON_MS,
    draw(u, colour) {
      let tip = null;
      cuts.forEach((el, i) => {
        const cut = Math.min(Math.max(u * total - spans[i].from, 0), spans[i].to - spans[i].from);
        el.setAttribute('stroke-dashoffset', String(lens[i] - cut));
        el.setAttribute('stroke', colour);
        if (u < 1 && u * total > spans[i].from && u * total < spans[i].to) tip = el.getPointAtLength(cut);
      });
      glow.setAttribute('opacity', tip ? '1' : '0');
      if (tip) glow.setAttribute('transform', `translate(${tip.x} ${tip.y})`);
    },
  };
}

// A menu word: revealed behind an arc sweeping left to right, hot, then cooling to its colour.
function wordJob(link) {
  const box = link.getBoundingClientRect();
  if (!box.width) return null;
  const svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('class', 'gm-cut-overlay');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('viewBox', `0 0 ${box.width} ${box.height}`);
  place(svg, box);
  const glowId = `gmh-${Math.random().toString(36).slice(2, 7)}`;
  svg.innerHTML = glowGradient(glowId) + `<circle r="${Math.min(10, box.height * 0.45)}" fill="url(#${glowId})" opacity="0"/>`;
  header.append(svg);
  const glow = svg.querySelector('circle');
  link.style.transition = 'none';
  return {
    target: link, svg, ms: WORD_MS, word: true,
    draw(u, colour, cooled) {
      link.style.clipPath = u >= 1 ? '' : `inset(0 ${(1 - u) * 100}% 0 0)`;
      link.style.color = cooled ? '' : colour;
      glow.setAttribute('opacity', u > 0 && u < 1 ? '1' : '0');
      glow.setAttribute('transform', `translate(${u * box.width} ${box.height / 2})`);
    },
  };
}

function run() {
  if (getComputedStyle(header).position === 'static') header.style.position = 'relative';
  const visible = (el) => el.offsetParent !== null;
  const marks = [...header.querySelectorAll('[data-cut]')].filter(visible);
  const icons = marks.filter((el) => el.dataset.cut !== 'logo');
  const logo = marks.filter((el) => el.dataset.cut === 'logo');
  const words = [...header.querySelectorAll('.gm-header__menu-link')].filter(visible);
  const order = [...icons.map(outlineJob), ...logo.map(outlineJob), ...words.map(wordJob)].filter(Boolean);
  if (!order.length) return;

  let at = START;
  for (const j of order) {
    if (j.word) j.draw(0, HOT, false); else j.target.classList.add('is-uncut');
    j.start = at; j.end = at + j.ms; at = j.end + GAP;
  }
  const finish = at + TEMPER + SETTLE;

  // A frame clock, not the wall clock: a page opened in a background tab gets no frames,
  // and the cut should wait to be seen rather than finish unwatched (as gm-cutsheet does).
  let t = 0, last = performance.now();
  const frame = (now) => {
    t += Math.min(now - last, 50);
    last = now;
    for (const j of order) {
      if (j.gone) continue;
      const u = clamp01((t - j.start) / j.ms);
      const age = clamp01((t - j.end) / TEMPER);
      j.draw(u, u < 1 ? HOT : temper(age), u >= 1 && age >= 1);
      if (!j.word) {
        if (u >= 1 && age > 0.35) j.target.classList.remove('is-uncut');
        j.svg.style.opacity = u >= 1 ? String(1 - clamp01((age - 0.4) / 0.6)) : '1';
      }
      if (u >= 1 && t > j.end + TEMPER + SETTLE) { j.svg.remove(); j.gone = true; }
    }
    if (t < finish) { requestAnimationFrame(frame); return; }
    document.removeEventListener('visibilitychange', resume);
    order.forEach((j) => {
      j.svg.remove();
      j.target.classList.remove('is-uncut');
      Object.assign(j.target.style, { clipPath: '', color: '', transition: '' });
    });
  };
  const resume = () => { if (document.visibilityState === 'visible') last = performance.now(); };
  document.addEventListener('visibilitychange', resume);
  requestAnimationFrame(frame);
}

// The hours strip follows the sheet: out once it has docked, tucked away while it hasn't.
function followDock() {
  const sync = () => { header.dataset.docked = sheet.dataset.state === 'done' ? 'true' : 'false'; };
  sync();
  new MutationObserver(sync).observe(sheet, { attributes: true, attributeFilter: ['data-state'] });
}

if (header) {
  customElements.whenDefined('gm-cutsheet').then(() => {
    followDock();
    if (!reduce) requestAnimationFrame(run);
  });
}

return {  };
})();
const __gm_cutlist = (() => {
// Cut-list parser: reads a list typed the way it is written on paper and does the
// arithmetic, so the customer never adds anything up (site-does-the-math).
//
//   8 @ 76.5        eight pieces at 76½ inches — inches unless marked
//   4 @ 3'2"        feet marked with '
//   12 @ 18 1/4     mixed fractions, 18-1/4, 18¼ and 18.25 all work
//
// Billing rounds each piece up to the whole foot; the cut stays exact.

const UNICODE = { '½': 1 / 2, '¼': 1 / 4, '¾': 3 / 4, '⅛': 1 / 8, '⅜': 3 / 8, '⅝': 5 / 8, '⅞': 7 / 8, '⅓': 1 / 3, '⅔': 2 / 3 };
const STICK_INCHES = 240;
const EPS = 1e-6;

// "18 1/4", "18-1/4", "18¼", "18.25", "1/2" → 18.25, 0.5; null when it isn't a number.
function number(text) {
  let s = text.trim().replace(/[½¼¾⅛⅜⅝⅞⅓⅔]/g, (c) => ` ${UNICODE[c]}`).trim();
  if (!s) return null;
  let m = s.match(/^(\d+(?:\.\d+)?)(?:[\s-]+(\d+)\/(\d+))?$/);
  if (m) return +m[1] + (m[2] ? +m[2] / +m[3] : 0);
  m = s.match(/^(\d+)\/(\d+)$/);
  if (m) return +m[1] / +m[2];
  m = s.match(/^(\d+(?:\.\d+)?)\s+(0?\.\d+)$/);            // "18 0.25" from a unicode fraction
  if (m) return +m[1] + +m[2];
  return null;
}

// A length in inches. Inches unless feet are marked with ' or ft.
function parseLength(text) {
  const s = text.trim().replace(/[′’‘`]/g, "'").replace(/[″“”]/g, '"').replace(/''/g, '"')
    .replace(/\s*(feet|foot|ft)\b\.?/gi, "'").replace(/\s*(inches|inch|in)\b\.?/gi, '"');
  const feet = s.match(/^(.*?)'\s*-?\s*(.*)$/);
  if (feet) {
    const ft = number(feet[1]);
    const rest = feet[2].replace(/"$/, '').trim();
    const inch = rest ? number(rest) : 0;
    if (ft === null || inch === null) return null;
    return ft * 12 + inch;
  }
  return number(s.replace(/"$/, ''));
}

// One line: "qty @ length". Also accepts x, ×, "pcs @" and "at".
function parseLine(raw) {
  const text = raw.trim();
  if (!text) return null;
  const m = text.match(/^(\d+)\s*(?:pcs?|pieces?)?\s*(?:@|×|x|\*|at)\s*(.+)$/i);
  if (!m) return { text, error: 'Write it as quantity @ length, like 8 @ 76.5' };
  const qty = +m[1];
  const inches = parseLength(m[2]);
  if (!qty) return { text, error: 'Quantity must be at least 1' };
  if (inches === null || !(inches > 0)) return { text, error: `Can't read the length "${m[2].trim()}"` };
  const line = { text, qty, inches, totalInches: qty * inches, billedFeetEach: Math.ceil(inches / 12 - EPS) };
  line.billedFeet = qty * line.billedFeetEach;
  if (inches > STICK_INCHES + EPS) line.warning = `Longer than a 20 ft stick — we'll call about a splice`;
  return line;
}

// The whole list. Lines with errors are kept so the customer sees which one to fix.
function parseCutList(text) {
  const lines = String(text || '').split(/\r?\n/).map(parseLine).filter(Boolean);
  const good = lines.filter((l) => !l.error);
  return {
    lines,
    errors: lines.filter((l) => l.error).length,
    pieces: good.reduce((n, l) => n + l.qty, 0),
    totalInches: good.reduce((n, l) => n + l.totalInches, 0),
    billedFeet: good.reduce((n, l) => n + l.billedFeet, 0),
    longestInches: good.reduce((n, l) => Math.max(n, l.inches), 0),
  };
}

// 983 → 81' 11"; 76.5 → 6' 4½". Rounded to the nearest 1/8", the shop's tolerance.
function formatFeetInches(inches) {
  const eighths = Math.round(inches * 8);
  const ft = Math.floor(eighths / 96);
  const inchEighths = eighths - ft * 96;
  const whole = Math.floor(inchEighths / 8);
  const frac = inchEighths % 8;
  const glyph = ['', '⅛', '¼', '⅜', '½', '⅝', '¾', '⅞'][frac];
  return `${ft}' ${whole}${glyph}"`;
}

return { STICK_INCHES, parseLength, parseLine, parseCutList, formatFeetInches };
})();
const __gm_catalog = (() => {
// Catalog rules, kept apart from any page so the site and a future connector answer
// the same way: which walls fit which size, weight per foot, and what is on the rack.
// The data lives in theme-src/assets/gm-catalog.json.

// Outside corner radius of structural tube, as a multiple of wall. Published weights
// (2 × 2 × 11 ga = 2.94 lb/ft) assume rounded corners, not sharp ones.
const TUBE_CORNER = 2;

function metal(catalog, id) { return catalog.metals.find((m) => m.id === id); }
function shape(catalog, id) { return catalog.shapes.find((s) => s.id === id); }
function size(shapeDef, id) { return shapeDef && shapeDef.sizes.find((s) => s.id === id); }
function shapesFor(catalog, metalId) { return catalog.shapes.filter((s) => s.metals.includes(metalId)); }
function isFreeform(shapeDef) { return Boolean(shapeDef && shapeDef.freeform); }

// Walls that physically fit: a tube or angle wall stays under a quarter of its smaller side.
function wallsFor(catalog, shapeDef, sizeDef) {
  if (!shapeDef || !shapeDef.walls || isFreeform(shapeDef) && shapeDef.kind !== 'plate') return [];
  const walls = catalog.walls[shapeDef.walls] || [];
  if (!sizeDef || sizeDef.a == null) return walls;
  const smallest = Math.min(sizeDef.a, sizeDef.b ?? sizeDef.a);
  if (shapeDef.kind === 'flat-bar') return walls.filter((w) => w.in < sizeDef.a);
  return walls.filter((w) => w.in < smallest / 4 - 1e-9);
}

// Cross-section area in square inches, from the drawing of each shape.
function area(kind, s, t) {
  const a = s.a, b = s.b ?? s.a;
  switch (kind) {
    case 'square-tube':
    case 'rect-tube': {
      const ro = TUBE_CORNER * t, ri = ro - t;
      return a * b - (a - 2 * t) * (b - 2 * t) - (4 - Math.PI) * (ro * ro - ri * ri);
    }
    case 'angle': return t * (a + b - t);
    case 'flat-bar': return t * a;
    case 'round-tube': return (Math.PI / 4) * (a * a - (a - 2 * t) * (a - 2 * t));
    case 'round-bar': return (Math.PI / 4) * a * a;
    default: return null;
  }
}

// Approximate pounds per foot; null when it can't be known (plate, remnants).
function lbPerFoot(catalog, metalId, shapeDef, sizeDef, wall) {
  const m = metal(catalog, metalId);
  if (!m || !shapeDef || !sizeDef) return null;
  if (sizeDef.lbft) return metalId === 'steel' ? sizeDef.lbft : null;
  const needsWall = ['square-tube', 'rect-tube', 'angle', 'flat-bar', 'round-tube'].includes(shapeDef.kind);
  if (needsWall && !wall) return null;
  const sq = area(shapeDef.kind, sizeDef, wall ? wall.in : 0);
  return sq == null ? null : sq * 12 * m.density;
}

function rackKey(metalId, shapeId, sizeId, wallId) {
  return [metalId, shapeId, sizeId, wallId].filter(Boolean).join('/');
}

// 'on_rack' or 'order_in'. A size counts as on the rack if any listed wall of it is.
function rackStatus(catalog, metalId, shapeId, sizeId, wallId) {
  const list = catalog.rack.on_rack || [];
  const key = rackKey(metalId, shapeId, sizeId, wallId);
  const hit = wallId ? list.includes(key) : list.some((k) => k === key || k.startsWith(key + '/'));
  return hit ? 'on_rack' : catalog.rack.default || 'order_in';
}

// "2 × 2 · 11 ga", the way the shop writes it.
function itemLabel(shapeDef, sizeDef, wall) {
  return [sizeDef && sizeDef.label, wall && wall.label].filter(Boolean).join(' · ');
}

return { metal, shape, size, shapesFor, isFreeform, wallsFor, lbPerFoot, rackKey, rackStatus, itemLabel };
})();
const __gm_cutlist_store = (() => {
// The customer's cut list, kept on their phone between pages until it is sent.
// Nothing is priced or charged here; the list becomes a request for Tim.

const KEY = 'gm-cutlist-v1';
const CUTLIST_EVENT = 'gm:cutlist';

function loadCutList() {
  try {
    const data = JSON.parse(localStorage.getItem(KEY) || '{}');
    return Array.isArray(data.items) ? data.items : [];
  } catch {
    return [];
  }
}

function save(items) {
  try { localStorage.setItem(KEY, JSON.stringify({ items })); } catch { /* private mode: the list lives for this page only */ }
  window.dispatchEvent(new CustomEvent(CUTLIST_EVENT, { detail: { count: items.length } }));
  return items;
}

// Adds a new item, or replaces the one being edited.
function putItem(item) {
  const items = loadCutList();
  const at = items.findIndex((i) => i.id === item.id);
  if (at >= 0) items[at] = item; else items.push(item);
  return save(items);
}

function removeItem(id) { return save(loadCutList().filter((i) => i.id !== id)); }
function clearCutList() { return save([]); }
function newItemId() { return `i${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`; }

return { CUTLIST_EVENT, loadCutList, putItem, removeItem, clearCutList, newItemId };
})();
const __gm_lead = (() => {
// Sends a lead (cut list, service request, commercial estimate) two ways at once:
// to the Zapier webhook that files it in Jobber, and through Shopify's own contact
// form, which emails the store. If Zapier is down or not set up yet, the email still
// arrives, so no lead depends on one service.

// Form fields rather than JSON: a cross-site JSON post would need CORS, which Zapier's
// catch hook doesn't answer, while form fields go through in no-cors mode.
async function postToWebhook(url, fields) {
  if (!url) return false;
  try {
    await fetch(url, { method: 'POST', mode: 'no-cors', body: new URLSearchParams(fields) });
    return true;
  } catch {
    return false;
  }
}

// Plain text for the email body and the Jobber request details.
function leadText(title, rows) {
  return [title, ''].concat(rows.filter(([, v]) => v !== '' && v != null).map(([k, v]) => `${k}: ${v}`)).join('\n');
}

// Wires a Shopify contact <form>: on submit, post to the webhook first, then let the
// form submit normally so Shopify's spam checks and email still run.
function wireLeadForm(form, { webhook, build }) {
  form.addEventListener('submit', async (event) => {
    if (form.dataset.sent) return;
    event.preventDefault();
    if (form.querySelector('[name="contact[company_url]"]')?.value) return; // bots fill the hidden field
    const lead = build(form);
    if (!lead) return;
    form.querySelector('[name="contact[body]"]').value = lead.text;
    const button = form.querySelector('[type="submit"]') || (form.id && document.querySelector(`[type="submit"][form="${form.id}"]`));
    if (button) { button.disabled = true; button.dataset.label = button.textContent; button.textContent = 'Sending…'; }
    await Promise.race([postToWebhook(webhook, lead.fields), new Promise((r) => setTimeout(r, 4000))]);
    form.dataset.sent = '1';
    form.submit();
  });
}

// <gm-lead-form kind="service|estimate" webhook="…">: wraps a Shopify contact form on the
// request pages and sends every filled field, labelled, as one lead.
const SKIP = new Set(['body', 'company_url', 'type']);
class GmLeadForm extends HTMLElement {
  connectedCallback() {
    const form = this.querySelector('form');
    if (!form || form.dataset.wired) return;
    form.dataset.wired = '1';
    wireLeadForm(form, {
      webhook: this.getAttribute('webhook'),
      build: (f) => {
        const title = (f.querySelector('[name="contact[type]"]')?.value || 'Request').toUpperCase() + ' (website)';
        const rows = [...f.querySelectorAll('[name^="contact["]')]
          .map((el) => [el.name.slice(8, -1), el])
          .filter(([key]) => !SKIP.has(key))
          .map(([key, el]) => [(el.closest('label')?.firstChild?.textContent || key).trim(), el.value.trim()]);
        const fields = { type: this.getAttribute('kind') === 'estimate' ? 'commercial_estimate' : 'service_request' };
        for (const [key, el] of [...f.querySelectorAll('[name^="contact["]')].map((el) => [el.name.slice(8, -1), el])) {
          if (!SKIP.has(key)) fields[key] = el.value.trim();
        }
        const text = leadText(title, rows);
        fields.summary = [fields.service || fields.project, fields.address || fields.company].filter(Boolean).join(' · ');
        fields.details = text;
        return { text, fields };
      },
    });
  }
}
if (!customElements.get('gm-lead-form')) customElements.define('gm-lead-form', GmLeadForm);

return { postToWebhook, leadText, wireLeadForm };
})();
const __gm_buy = (() => {
// <gm-buy>: the Buy Metal flow from the Figma board (P1b → P5). One page: metal,
// shape, size and wall, then the cut list typed the way it is written on paper.
// The bottom zone stays in the thumb's reach; the site does every sum.
//
//   <gm-buy catalog="…/gm-catalog.json" asset-base="…/assets/" cutlist-url="/cart"
//           headline="Metal,|cut to length." accent="Ready|today." photo="…jpg"></gm-buy>
//
// Deep links: ?metal=steel&shape=square-tube&size=2x2&wall=11ga, and ?edit=<item id>.

const { parseCutList, formatFeetInches } = __gm_cutlist;
const { metal, shape, size, shapesFor, wallsFor, lbPerFoot, rackStatus, itemLabel, isFreeform } = __gm_catalog;
const { loadCutList, putItem, newItemId } = __gm_cutlist_store;

const BUY_CSS = `
gm-buy { display: block; position: relative; min-height: 100dvh; color: #f3f5f6; font-family: Figtree, var(--font-body--family, system-ui), sans-serif; background: #0c0d0f; overflow: hidden; }
gm-buy *, gm-buy *::before, gm-buy *::after { box-sizing: border-box; }
gm-buy button { font: inherit; color: inherit; cursor: pointer; }
.gmb__photo, .gmb__shade { position: absolute; inset: 0; }
.gmb__photo { width: 100%; height: 100%; object-fit: cover; }
.gmb__shade { background: linear-gradient(to bottom, rgba(12,13,15,.8), rgba(12,13,15,.3) 60%, rgba(12,13,15,.5)); }
.gmb__headline { position: relative; margin: 0; padding: 28px 18px 0; font-weight: 800; font-size: clamp(44px, 13.8vw, 72px); line-height: 1.05; letter-spacing: -0.02em; }
.gmb__headline span { display: block; }
.gmb__headline .gmb__accent { color: var(--gm-orange-text, #e0552c); }
.gmb__system { position: absolute; left: 0; right: 0; bottom: 0; display: flex; flex-direction: column; }
.gmb__sheet { position: relative; padding: 8px 18px 20px; border-radius: 26px 26px 0 0; background: rgba(16,19,22,.9); -webkit-backdrop-filter: blur(28px); backdrop-filter: blur(28px); box-shadow: 0 -24px 60px rgba(0,0,0,.8), inset 0 1px 0 rgba(255,255,255,.14); max-height: 62dvh; overflow-y: auto; }
.gmb__handle { width: 38px; height: 4px; margin: 0 auto; border-radius: 2px; background: rgba(255,255,255,.2); }
.gmb__title { margin: 0; padding: 12px 0 8px; font-size: 16px; font-weight: 600; letter-spacing: .84px; text-transform: uppercase; color: #cdd2d7; }
.gmb__sub { margin: 0; padding: 18px 0 0; font-size: 12px; font-weight: 600; letter-spacing: .84px; text-transform: uppercase; color: #767f86; }
.gmb__grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; padding-top: 12px; }
.gmb__grid--walls { grid-template-columns: repeat(4, 1fr); padding-top: 10px; }
.gmb__cell { position: relative; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; min-height: 84px; padding: 8px 4px; border: 0; border-radius: 16px; background: transparent; }
.gmb__cell[aria-pressed="true"] { background: rgba(255,255,255,.1); }
.gmb__cell:focus-visible { outline: 2px solid #8db3d9; outline-offset: 2px; }
.gmb__cell img { width: 30px; height: 30px; }
.gmb__cell-name { font-size: 11px; color: #767f86; }
.gmb__cell[aria-pressed="true"] .gmb__cell-name { color: #f3f5f6; }
.gmb__cell-size { font-size: 17px; font-weight: 600; font-variant-numeric: tabular-nums; }
.gmb__grid--walls .gmb__cell { min-height: 64px; gap: 2px; }
.gmb__cell-wall { font-size: 15px; font-weight: 600; font-variant-numeric: tabular-nums; }
.gmb__cell-dec { font-size: 11px; color: #767f86; font-variant-numeric: tabular-nums; }
.gmb__status { display: flex; align-items: center; gap: 4px; font-size: 11px; font-weight: 500; color: #767f86; }
.gmb__status::before { content: ""; width: 5px; height: 5px; border-radius: 50%; background: currentColor; }
.gmb__status--on_rack { color: #6cc08a; }
.gmb__remnants { display: grid; gap: 3px; width: 24px; }
.gmb__remnants i { display: block; height: 4px; border: 1.6px solid #a2aab1; }
.gmb__context { margin: 0; padding-top: 12px; font-size: 12px; letter-spacing: .84px; text-transform: uppercase; color: #767f86; }
.gmb__label { margin: 0; padding-top: 14px; font-size: 12px; font-weight: 600; letter-spacing: .96px; color: #767f86; }
.gmb__entry { position: relative; margin-top: 10px; border: 1.5px solid rgba(222,92,51,.9); border-radius: 14px; background: rgba(255,255,255,.1); }
.gmb__textarea, .gmb__totals { font: 600 20px/30px Figtree, var(--font-body--family, system-ui), sans-serif; padding: 14px 16px; }
.gmb__textarea { display: block; width: 100%; min-height: 128px; margin: 0; border: 0; resize: none; background: transparent; color: #f3f5f6; white-space: pre; overflow-x: auto; }
.gmb__textarea::placeholder { color: #767f86; opacity: 1; }
.gmb__textarea:focus { outline: none; }
.gmb__entry:focus-within { box-shadow: 0 0 0 3px rgba(222,92,51,.25); }
.gmb__totals { position: absolute; top: 0; right: 0; pointer-events: none; text-align: right; font-weight: 400; font-size: 15px; color: #767f86; font-variant-numeric: tabular-nums; }
.gmb__totals div { height: 30px; white-space: nowrap; }
.gmb__totals .gmb__bad { color: #e0552c; }
.gmb__hint { margin: 10px 0 0; font-size: 13px; line-height: 1.35; color: #767f86; }
.gmb__errors { margin: 8px 0 0; font-size: 13px; color: #e0552c; }
.gmb__sum { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; padding-top: 14px; font-variant-numeric: tabular-nums; }
.gmb__sum strong { font-size: 17px; font-weight: 600; }
.gmb__sum-right { display: grid; justify-items: end; gap: 2px; }
.gmb__sum-right span { font-size: 13px; color: #767f86; }
.gmb__rack { display: flex; align-items: center; gap: 8px; margin: 0; padding-top: 12px; font-size: 13px; color: #a2aab1; }
.gmb__rack::before { content: ""; width: 8px; height: 8px; border-radius: 50%; background: #767f86; }
.gmb__rack--on_rack { color: #6cc08a; }
.gmb__rack--on_rack::before { background: #6cc08a; }
.gmb__added { display: flex; align-items: center; gap: 12px; padding: 14px 0 18px; }
.gmb__tick { display: grid; place-items: center; flex: none; width: 36px; height: 36px; border-radius: 18px; background: rgba(108,192,138,.18); color: #6cc08a; font-size: 18px; font-weight: 600; }
.gmb__added strong { display: block; font-size: 17px; font-weight: 600; }
.gmb__added span { font-size: 13px; color: #767f86; }
.gmb__rule { height: 1px; margin: 0 0 14px; background: rgba(255,255,255,.08); }
.gmb__next { display: grid; gap: 14px; }
.gmb__option { display: flex; align-items: center; gap: 14px; width: 100%; padding: 14px 16px; border: 1px solid rgba(255,255,255,.1); border-radius: 14px; background: rgba(255,255,255,.1); text-align: left; }
.gmb__option img, .gmb__option .gmb__glyph { flex: none; width: 28px; height: 28px; }
.gmb__glyph { position: relative; }
.gmb__glyph--size::before, .gmb__glyph--size::after { content: ""; position: absolute; border: 2px solid #f3f5f6; }
.gmb__glyph--size::before { inset: 4px; }
.gmb__glyph--size::after { inset: 8px; border-width: 1.5px; }
.gmb__glyph--shape::before { content: ""; position: absolute; left: 6px; top: 4px; width: 3px; height: 20px; background: #f3f5f6; }
.gmb__glyph--shape::after { content: ""; position: absolute; left: 6px; top: 21px; width: 18px; height: 3px; background: #f3f5f6; }
.gmb__option-text { flex: 1; min-width: 0; }
.gmb__option-text strong { display: block; font-size: 17px; font-weight: 600; }
.gmb__option-text span { font-size: 13px; color: #767f86; }
.gmb__chev { font-size: 24px; color: #767f86; }
.gmb__bar { padding: 14px 16px calc(28px + env(safe-area-inset-bottom)); background: #f2f4f6; color: #111; }
.gmb__metals, .gmb__trail { display: flex; gap: 6px; padding: 8px 0; }
.gmb__metal { flex: 1 1 0; display: flex; align-items: center; justify-content: center; gap: 8px; min-width: 0; padding: 16px 10px; border: 1px solid rgba(0,0,0,.1); border-radius: 12px; background: #fff; color: #111; font-size: 15px; font-weight: 600; }
.gmb__metal[aria-pressed="true"] { border: 2px solid var(--gm-orange, #c2451e); padding: 15px 9px; }
.gmb__metal img { width: 18px; height: 18px; }
.gmb__chip { display: flex; flex-direction: column; align-items: flex-start; gap: 3px; flex: 0 0 84.5px; min-width: 0; padding: 9px 8px; border: 1px solid rgba(0,0,0,.1); border-radius: 12px; background: #fff; color: #111; text-align: left; overflow: hidden; }
.gmb__chip:last-child { flex: 1 1 0; }
.gmb__chip--on { border: 2px solid var(--gm-orange, #c2451e); padding: 8px 7px; }
.gmb__chip--empty { border: 1px dashed rgba(0,0,0,.18); background: transparent; }
.gmb__chip small { font-size: 10px; font-weight: 600; letter-spacing: .8px; opacity: .55; }
.gmb__chip b { display: flex; align-items: center; gap: 6px; max-width: 100%; font-size: 13px; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; letter-spacing: -0.01em; }
.gmb__chip--empty b { font-weight: 400; opacity: .35; }
.gmb__chip b img { width: 14px; height: 14px; }
.gmb__chip b img.gmb__dark { filter: brightness(0); }
.gmb__go { display: block; width: 100%; margin-top: 6px; padding: 17px 16px; border: 0; border-radius: 28px; background: var(--gm-orange, #c2451e); color: #fff; font-size: 17px; font-weight: 600; text-align: center; text-decoration: none; }
.gmb__go:disabled { opacity: .45; cursor: default; }
.gmb__go:focus-visible { outline: 3px solid #8db3d9; outline-offset: 2px; }
.gmb__sr { position: absolute; width: 1px; height: 1px; margin: -1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }
@media (min-width: 900px) {
  .gmb__headline { padding: 64px max(40px, calc((100% - 1180px) / 2)) 0; }
  .gmb__system { left: auto; right: max(24px, calc((100% - 1180px) / 2)); bottom: 24px; width: 440px; border-radius: 26px; overflow: hidden; box-shadow: 0 30px 80px rgba(0,0,0,.55); }
  .gmb__bar { padding-bottom: 20px; }
}
`;

const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const STEPS = ['metal', 'shape', 'size', 'cut', 'added'];

class GmBuy extends HTMLElement {
  async connectedCallback() {
    if (this.state) return;
    if (!document.getElementById('gm-buy-css')) {
      const style = document.createElement('style');
      style.id = 'gm-buy-css';
      style.textContent = BUY_CSS;
      document.head.append(style);
    }
    this.base = this.getAttribute('asset-base') || '';
    this.state = { step: 'metal', metal: 'steel', shape: null, size: null, wall: null, text: '', editId: null, added: null };
    this.renderShell();
    try {
      this.catalog = await (await fetch(this.getAttribute('catalog'))).json();
    } catch {
      this.querySelector('.gmb__system').innerHTML = `<div class="gmb__bar"><p>The size list didn't load. Call the shop, or try again in a moment.</p></div>`;
      return;
    }
    this.readLinks();
    this.render();
  }

  asset(name) { return name ? this.base + name : ''; }

  readLinks() {
    const q = new URLSearchParams(location.search);
    const s = this.state, c = this.catalog;
    const edit = q.get('edit') && loadCutList().find((i) => i.id === q.get('edit'));
    if (edit) {
      Object.assign(s, { metal: edit.metal, shape: edit.shape, size: edit.size, wall: edit.wall, text: edit.text, editId: edit.id, step: 'cut' });
      return;
    }
    if (metal(c, q.get('metal'))) s.metal = q.get('metal');
    const sh = shape(c, q.get('shape'));
    if (sh && sh.metals.includes(s.metal)) {
      s.shape = sh.id;
      s.step = isFreeform(sh) && sh.kind !== 'plate' ? 'cut' : 'size';
      if (sh.kind === 'plate') s.size = 'plate';
      const z = size(sh, q.get('size'));
      if (z) {
        s.size = z.id;
        const w = wallsFor(c, sh, z).find((x) => x.id === q.get('wall'));
        if (w) s.wall = w.id;
        if (w || !wallsFor(c, sh, z).length) s.step = 'cut';
      }
    }
  }

  renderShell() {
    const lines = (a) => (a || '').split('|').map((l) => `<span>${esc(l)}</span>`).join('');
    const photo = this.getAttribute('photo');
    this.innerHTML = `
      ${photo ? `<img class="gmb__photo" src="${esc(photo)}" alt="" loading="eager">` : ''}
      <div class="gmb__shade" aria-hidden="true"></div>
      <h1 class="gmb__headline">${lines(this.getAttribute('headline') || 'Metal,|cut to length.')}<span class="gmb__accent">${lines(this.getAttribute('accent') || 'Ready|today.')}</span></h1>
      <div class="gmb__system"><div class="gmb__bar"><p>Loading sizes…</p></div></div>
      <p class="gmb__sr" aria-live="polite"></p>`;
  }

  // Current selections as catalog objects.
  get sel() {
    const c = this.catalog, s = this.state;
    const sh = shape(c, s.shape), z = size(sh, s.size);
    const w = wallsFor(c, sh, z).find((x) => x.id === s.wall) || null;
    return { m: metal(c, s.metal), sh, z, w, walls: wallsFor(c, sh, z) };
  }

  go(step) { this.state.step = step; this.render(); this.querySelector('.gmb__sheet, .gmb__bar')?.scrollTo?.(0, 0); }

  render() {
    const s = this.state;
    const system = this.querySelector('.gmb__system');
    const sheet = { shape: this.shapeSheet, size: this.sizeSheet, cut: this.cutSheet, added: this.addedSheet }[s.step];
    system.innerHTML = `${sheet ? `<section class="gmb__sheet" aria-label="${esc(s.step)}"><div class="gmb__handle" aria-hidden="true"></div>${sheet.call(this)}</section>` : ''}
      <div class="gmb__bar">${s.step === 'metal' ? this.metalPicker() : this.trail()}${this.primary()}</div>`;
    this.bind();
    if (s.step === 'cut') this.updateTotals();
  }

  metalPicker() {
    return `<div class="gmb__metals" role="group" aria-label="Metal">${this.catalog.metals.map((m) => `
      <button type="button" class="gmb__metal" data-metal="${m.id}" aria-pressed="${m.id === this.state.metal}">
        <img src="${esc(this.asset(m.swatch))}" alt="" width="18" height="18">${esc(m.name)}</button>`).join('')}</div>`;
  }

  trail() {
    const s = this.state, { m, sh, z, w } = this.sel;
    const count = loadCutList().length;
    const cutValue = s.step === 'added' ? `${count} item${count === 1 ? '' : 's'}` : (s.step === 'cut' ? this.cutChipValue() : '');
    const chip = (key, label, value, icon, step) => {
      const on = s.step === key || (key === 'cut' && s.step === 'added');
      const cls = on ? ' gmb__chip--on' : value ? '' : ' gmb__chip--empty';
      return `<button type="button" class="gmb__chip${cls}" data-step="${step}" ${value && !on ? '' : 'tabindex="-1"'}>
        <small>${label}</small><b>${icon || ''}${value ? esc(value) : '—'}</b></button>`;
    };
    const shapeIcon = sh && sh.icon ? `<img class="gmb__dark" src="${esc(this.asset(sh.icon))}" alt="">` : '';
    const sizeValue = sh && isFreeform(sh) && sh.kind !== 'plate' ? '' : (z ? (sh.kind === 'plate' ? (w ? w.label : '') : itemLabel(sh, z, w) + (this.sel.walls.length && !w ? ' · wall?' : '')) : '');
    return `<div class="gmb__trail">
      ${chip('metal', 'METAL', m && m.name, m ? `<img src="${esc(this.asset(m.swatch))}" alt="">` : '', 'metal')}
      ${chip('shape', 'SHAPE', sh && sh.short, shapeIcon, 'shape')}
      ${chip('size', 'SIZE', sizeValue, '', 'size')}
      ${chip('cut', 'CUT LIST', cutValue, '', 'cut')}</div>`;
  }

  cutChipValue() {
    const { sh } = this.sel;
    if (isFreeform(this.sel.sh)) return this.state.text.trim() ? 'written' : '';
    const p = parseCutList(this.state.text);
    return p.pieces ? `${p.pieces} pcs` : '';
  }

  shapeSheet() {
    const s = this.state;
    return `<h2 class="gmb__title">Choose shape</h2>
      <div class="gmb__grid" role="group" aria-label="Shape">${shapesFor(this.catalog, s.metal).map((sh) => `
        <button type="button" class="gmb__cell" data-shape="${sh.id}" aria-pressed="${sh.id === s.shape}">
          ${sh.icon ? `<img src="${esc(this.asset(sh.icon))}" alt="" width="30" height="30">` : '<span class="gmb__remnants" aria-hidden="true"><i></i><i style="width:66%"></i><i style="width:38%"></i></span>'}
          <span class="gmb__cell-name">${esc(sh.name)}</span></button>`).join('')}</div>`;
  }

  sizeSheet() {
    const c = this.catalog, s = this.state, { sh, z, walls } = this.sel;
    const plate = sh.kind === 'plate';
    const sizes = plate ? '' : `<h2 class="gmb__title">Choose size</h2>
      <div class="gmb__grid" role="group" aria-label="Size">${sh.sizes.map((x) => {
        const st = rackStatus(c, s.metal, sh.id, x.id);
        return `<button type="button" class="gmb__cell" data-size="${x.id}" aria-pressed="${x.id === s.size}">
          <span class="gmb__cell-size">${esc(x.label)}</span>
          <span class="gmb__status gmb__status--${st}">${esc(c.rack.label[st])}</span></button>`;
      }).join('')}</div>`;
    const wallGrid = (z && walls.length) ? `<h3 class="${plate ? 'gmb__title' : 'gmb__sub'}">${plate ? 'Choose thickness' : 'Wall thickness'}</h3>
      <div class="gmb__grid gmb__grid--walls" role="group" aria-label="Wall thickness">${walls.map((w) => `
        <button type="button" class="gmb__cell" data-wall="${w.id}" aria-pressed="${w.id === s.wall}">
          <span class="gmb__cell-wall">${esc(w.label)}</span><span class="gmb__cell-dec">${w.in.toFixed(3).replace(/^0/, '')}"</span></button>`).join('')}</div>` : '';
    return sizes + wallGrid;
  }

  cutSheet() {
    const { m, sh, z, w } = this.sel;
    const free = isFreeform(sh) && sh.kind !== 'plate';
    const context = [sh.name, !free && sh.kind !== 'plate' && z ? z.label : '', w ? `${w.label}${sh.walls === 'tube' ? ` (${w.in.toFixed(3).replace(/^0/, '')}")` : ''}` : ''].filter(Boolean).join(' · ');
    if (isFreeform(sh)) {
      return `<p class="gmb__context">${esc(m.name)} · ${esc(context)}</p>
        <p class="gmb__label">WHAT YOU NEED</p>
        <div class="gmb__entry"><textarea class="gmb__textarea" style="white-space:pre-wrap;font-weight:500;font-size:17px;line-height:26px" rows="4" aria-label="What you need" placeholder="${esc(sh.kind === 'plate' ? '4 @ 6 × 6' : '2 × 2 angle, about 10 ft')}">${esc(this.state.text)}</textarea></div>
        <p class="gmb__hint">${esc(sh.freeform)}</p>
        <p class="gmb__rack">${esc(this.catalog.rack.line.order_in)}</p>`;
    }
    return `<p class="gmb__context">${esc(context)}</p>
      <p class="gmb__label">YOUR CUT LIST</p>
      <div class="gmb__entry"><textarea class="gmb__textarea" rows="4" spellcheck="false" autocapitalize="off" autocomplete="off" inputmode="text"
        aria-label="Your cut list, one cut per line: quantity @ length" placeholder="8 @ 76.5&#10;4 @ 3'2&quot;">${esc(this.state.text)}</textarea><div class="gmb__totals" aria-hidden="true"></div></div>
      <p class="gmb__hint">One cut per line: quantity @ length. Inches unless you mark feet with '. Paste a whole list — we add it up.</p>
      <p class="gmb__errors" hidden></p>
      <div class="gmb__sum" hidden><strong class="gmb__pieces"></strong><span class="gmb__sum-right"><strong class="gmb__cut"></strong><span class="gmb__billed"></span></span></div>
      <p class="gmb__rack"></p>`;
  }

  addedSheet() {
    const a = this.state.added, { m, sh } = this.sel;
    return `<div class="gmb__added"><span class="gmb__tick" aria-hidden="true">✓</span><div><strong>Added to your cut list</strong><span>${esc(a ? a.summary : '')}</span></div></div>
      <div class="gmb__rule"></div>
      <p class="gmb__label" style="padding-top:0;color:#cdd2d7">WHAT'S NEXT</p>
      <div class="gmb__next" style="padding-top:14px">
        ${sh && !isFreeform(sh) ? `<button type="button" class="gmb__option" data-next="size"><span class="gmb__glyph gmb__glyph--size" aria-hidden="true"></span><span class="gmb__option-text"><strong>Another size</strong><span>${esc(sh.name)} · ${esc(m.name.toLowerCase())} — straight to size &amp; wall</span></span><span class="gmb__chev" aria-hidden="true">›</span></button>` : ''}
        <button type="button" class="gmb__option" data-next="shape"><span class="gmb__glyph gmb__glyph--shape" aria-hidden="true"></span><span class="gmb__option-text"><strong>Another shape</strong><span>${esc(m.name)} — back to the shape grid</span></span><span class="gmb__chev" aria-hidden="true">›</span></button>
        <button type="button" class="gmb__option" data-next="metal"><img src="${esc(this.asset('gm-icon-another-metal.svg'))}" alt="" width="28" height="28"><span class="gmb__option-text"><strong>Another metal</strong><span>${esc(this.catalog.metals.filter((x) => x.id !== m.id).map((x) => x.name).join(' or '))}</span></span><span class="gmb__chev" aria-hidden="true">›</span></button>
      </div>`;
  }

  // The orange button: always says what happens next, and is only live when it can.
  primary() {
    const s = this.state, { sh, z, w, walls } = this.sel;
    let label = '', enabled = true, attr = '';
    if (s.step === 'metal') label = 'Choose shape';
    else if (s.step === 'shape') { label = sh && isFreeform(sh) && sh.kind !== 'plate' ? 'Tell us what you need' : 'Size & wall'; enabled = Boolean(sh); }
    else if (s.step === 'size') {
      const ready = sh.kind === 'plate' ? Boolean(w) : Boolean(z) && (!walls.length || Boolean(w));
      label = !z && sh.kind !== 'plate' ? 'Choose a size' : ready ? (isFreeform(sh) ? 'Describe the pieces' : 'Enter cut list') : (sh.kind === 'plate' ? 'Choose a thickness' : 'Choose a wall thickness');
      enabled = ready;
    } else if (s.step === 'cut') { label = 'Add to cut list'; attr = 'data-add'; }
    else if (s.step === 'added') {
      const n = loadCutList().length;
      return `<a class="gmb__go" href="${esc(this.getAttribute('cutlist-url') || '/cart')}">Review cut list · ${n} item${n === 1 ? '' : 's'}</a>`;
    }
    return `<button type="button" class="gmb__go" ${attr} ${enabled ? '' : 'disabled'}>${esc(label)}</button>`;
  }

  bind() {
    const s = this.state;
    this.querySelectorAll('[data-metal]').forEach((b) => b.onclick = () => {
      s.metal = b.dataset.metal;
      if (s.shape && !shape(this.catalog, s.shape).metals.includes(s.metal)) Object.assign(s, { shape: null, size: null, wall: null });
      this.render();
    });
    this.querySelectorAll('[data-shape]').forEach((b) => b.onclick = () => {
      if (s.shape !== b.dataset.shape) Object.assign(s, { shape: b.dataset.shape, size: shape(this.catalog, b.dataset.shape).kind === 'plate' ? 'plate' : null, wall: null, text: '' });
      this.render();
    });
    this.querySelectorAll('[data-size]').forEach((b) => b.onclick = () => {
      s.size = b.dataset.size;
      if (!this.sel.walls.some((w) => w.id === s.wall)) s.wall = null;
      this.render();
      this.querySelector('.gmb__grid--walls')?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
    this.querySelectorAll('[data-wall]').forEach((b) => b.onclick = () => { s.wall = b.dataset.wall; this.render(); });
    this.querySelectorAll('.gmb__chip[data-step]').forEach((b) => b.onclick = () => {
      const target = b.dataset.step, have = { metal: true, shape: Boolean(s.shape), size: Boolean(s.size), cut: Boolean(s.size || (this.sel.sh && isFreeform(this.sel.sh))) };
      if (have[target] && STEPS.indexOf(target) < STEPS.indexOf(s.step)) this.go(target);
    });
    this.querySelectorAll('[data-next]').forEach((b) => b.onclick = () => {
      const next = b.dataset.next;
      Object.assign(s, { text: '', editId: null, added: null });
      if (next === 'size') Object.assign(s, { size: null, wall: null });
      if (next === 'shape') Object.assign(s, { shape: null, size: null, wall: null });
      if (next === 'metal') Object.assign(s, { shape: null, size: null, wall: null });
      this.go(next);
    });
    const go = this.querySelector('button.gmb__go');
    if (go && !go.hasAttribute('data-add')) go.onclick = () => {
      const sh = this.sel.sh;
      const next = { metal: 'shape', shape: sh && isFreeform(sh) && sh.kind !== 'plate' ? 'cut' : 'size', size: 'cut' }[s.step];
      if (next) this.go(next);
    };
    if (go && go.hasAttribute('data-add')) go.onclick = () => this.add();
    const ta = this.querySelector('.gmb__textarea');
    if (ta) {
      ta.oninput = () => { s.text = ta.value; this.updateTotals(); };
      ta.onscroll = () => { const t = this.querySelector('.gmb__totals'); if (t) t.style.transform = `translateY(${-ta.scrollTop}px)`; };
    }
  }

  // Live sums beside each typed line, and the button that states the billed feet.
  updateTotals() {
    const s = this.state, { sh } = this.sel;
    const go = this.querySelector('button.gmb__go');
    const chip = this.querySelector('.gmb__chip--on b');
    if (isFreeform(sh)) {
      const has = s.text.trim().length > 0;
      if (go) { go.disabled = !has; go.textContent = 'Add to cut list'; }
      if (chip) chip.textContent = has ? 'written' : '—';
      return;
    }
    const raw = s.text.split(/\r?\n/);
    const parsed = parseCutList(s.text);
    let k = 0;
    const rows = raw.map((line) => {
      if (!line.trim()) return '<div></div>';
      const l = parsed.lines[k++];
      return l.error ? '<div class="gmb__bad">?</div>' : `<div>= ${esc(formatFeetInches(l.totalInches))}</div>`;
    });
    const totals = this.querySelector('.gmb__totals');
    if (totals) totals.innerHTML = rows.join('');
    const bad = parsed.lines.map((l, i) => l.error ? `Line ${i + 1}: ${l.error}` : l.warning ? `Line ${i + 1}: ${l.warning}` : '').filter(Boolean);
    const err = this.querySelector('.gmb__errors');
    err.hidden = !bad.length;
    err.textContent = bad.join(' · ');
    const sum = this.querySelector('.gmb__sum');
    sum.hidden = !parsed.pieces;
    this.querySelector('.gmb__pieces').textContent = `${parsed.pieces} piece${parsed.pieces === 1 ? '' : 's'}`;
    this.querySelector('.gmb__cut').textContent = `${formatFeetInches(parsed.totalInches)} cut`;
    this.querySelector('.gmb__billed').textContent = `billed as ${parsed.billedFeet} ft`;
    const st = rackStatus(this.catalog, s.metal, s.shape, s.size, s.wall);
    const rack = this.querySelector('.gmb__rack');
    rack.className = `gmb__rack gmb__rack--${st}`;
    rack.textContent = this.catalog.rack.line[st];
    const ready = parsed.pieces > 0 && !parsed.errors;
    if (go) { go.disabled = !ready; go.textContent = ready ? `Add to cut list · ${parsed.billedFeet} ft` : parsed.errors ? 'Fix the marked line' : 'Add to cut list'; }
    if (chip) chip.textContent = parsed.pieces ? `${parsed.pieces} pcs` : '—';
    this.querySelector('.gmb__sr').textContent = parsed.pieces ? `${parsed.pieces} pieces, billed as ${parsed.billedFeet} feet` : '';
  }

  add() {
    const s = this.state, c = this.catalog, { m, sh, z, w } = this.sel;
    const free = isFreeform(sh);
    const parsed = free ? null : parseCutList(s.text);
    if (free ? !s.text.trim() : !parsed.pieces || parsed.errors) return;
    const lbft = lbPerFoot(c, s.metal, sh, z, w);
    const label = sh.kind === 'plate' ? `${w.label} plate` : sh.kind === 'remnants' ? 'Remnants' : itemLabel(sh, z, w);
    const item = {
      id: s.editId || newItemId(), metal: s.metal, shape: sh.id, size: s.size, wall: s.wall,
      metalName: m.name, shapeName: sh.name, label, text: s.text.trim(), freeform: free,
      rack: rackStatus(c, s.metal, sh.id, s.size, s.wall), lbft,
      ...(parsed ? { pieces: parsed.pieces, totalInches: parsed.totalInches, billedFeet: parsed.billedFeet, longestInches: parsed.longestInches } : {}),
    };
    putItem(item);
    const summary = free ? `${label} · ${m.name.toLowerCase()}` : `${label} ${sh.name.toLowerCase()} · ${parsed.pieces} pcs · ${parsed.billedFeet} ft`;
    Object.assign(s, { added: { summary }, editId: null });
    if (new URLSearchParams(location.search).has('edit')) history.replaceState(null, '', location.pathname);
    this.go('added');
  }
}

if (!customElements.get('gm-buy')) customElements.define('gm-buy', GmBuy);

return {  };
})();
const __gm_cutlist_page = (() => {
// <gm-cutlist-page>: the cut list page from the Figma board (P6), grouped the way the
// shop racks steel, with the weight for the truck. Until prices exist, "Send my cut
// list" turns the list into a request: Jobber through the webhook, and Shopify's own
// contact email as the backup (web/gm-lead.js).
//
//   <gm-cutlist-page buy-url="/collections/all" webhook="https://hooks.zapier.com/…">
//     <form id="gm-cutlist-form" …>  ← Shopify's {% form 'contact' %}, rendered by the section
//   </gm-cutlist-page>

const { formatFeetInches } = __gm_cutlist;
const { loadCutList, removeItem, clearCutList, CUTLIST_EVENT } = __gm_cutlist_store;
const { wireLeadForm, leadText } = __gm_lead;

const PAGE_CSS = `
gm-cutlist-page { --gm-steel-muted: #767f86; --gm-field-ink: #f3f5f6; display: block; min-height: 100dvh; padding: 12px 18px calc(170px + env(safe-area-inset-bottom)); background: #0c0d0f; color: #f3f5f6; font-family: Figtree, var(--font-body--family, system-ui), sans-serif; }
gm-cutlist-page *, gm-cutlist-page *::before, gm-cutlist-page *::after { box-sizing: border-box; }
gm-cutlist-page button, gm-cutlist-page input, gm-cutlist-page textarea { font: inherit; color: inherit; }
.gmc__inner { width: min(640px, 100%); margin-inline: auto; display: grid; gap: 10px; }
.gmc__head h1 { margin: 0; font-size: 28px; font-weight: 600; }
.gmc__head p { margin: 4px 0 0; font-size: 13px; color: #767f86; }
.gmc__group { margin: 6px 0 0; font-size: 12px; font-weight: 600; letter-spacing: .96px; color: #cdd2d7; }
.gmc__item { display: grid; gap: 6px; padding: 12px 14px; border: 1px solid rgba(255,255,255,.08); border-radius: 14px; background: rgba(255,255,255,.1); }
.gmc__row { display: flex; align-items: baseline; justify-content: space-between; gap: 12px; }
.gmc__label { font-size: 17px; font-weight: 600; }
.gmc__feet { font-size: 17px; font-weight: 600; font-variant-numeric: tabular-nums; white-space: nowrap; }
.gmc__cuts { margin: 0; font-size: 15px; opacity: .85; white-space: pre-wrap; overflow-wrap: anywhere; }
.gmc__meta { font-size: 12px; color: #767f86; font-variant-numeric: tabular-nums; }
.gmc__actions { display: flex; gap: 4px; margin-right: -8px; }
.gmc__actions a, .gmc__actions button { padding: 8px; border: 0; background: none; color: #f3f5f6; font-size: 14px; font-weight: 600; text-decoration: none; opacity: .9; cursor: pointer; }
.gmc__actions button { color: #a2aab1; font-weight: 500; }
.gmc__add { display: block; padding: 14px; border: 1px dashed rgba(255,255,255,.28); border-radius: 14px; color: #f3f5f6; font-size: 15px; font-weight: 600; text-align: center; text-decoration: none; }
.gmc__totals { display: grid; gap: 8px; padding-top: 8px; border-top: 1px solid rgba(255,255,255,.08); margin-top: 8px; font-size: 14px; color: #767f86; font-variant-numeric: tabular-nums; }
.gmc__totals div { display: flex; justify-content: space-between; gap: 12px; }
.gmc__totals .gmc__grand { font-size: 17px; font-weight: 600; color: #f3f5f6; }
.gmc__note { margin: 2px 0 0; font-size: 13px; color: #a2aab1; }
.gmc__empty { display: grid; gap: 14px; padding: 40px 0; text-align: center; }
.gmc__empty p { margin: 0; color: #a2aab1; }
.gmc__form { display: grid; gap: 10px; margin-top: 18px; }
.gmc__form h2 { margin: 0; font-size: 12px; font-weight: 600; letter-spacing: .96px; color: #cdd2d7; }
.gmc__field { display: grid; gap: 6px; font-size: 13px; color: #a2aab1; }
.gmc__field input, .gmc__field textarea { width: 100%; min-height: 52px; padding: 14px 16px; border: 1px solid rgba(255,255,255,.18); border-radius: 14px; background: rgba(255,255,255,.08); font-size: 17px; }
.gmc__field textarea { min-height: 84px; resize: vertical; }
/* Horizon's placeholder grey is meant for white fields and vanishes on steel. */
.gmc__field input, .gmc__field textarea { color: var(--gm-field-ink); }
.gmc__field input::placeholder, .gmc__field textarea::placeholder { color: var(--gm-steel-muted); opacity: 1; }
.gmc__field input:focus, .gmc__field textarea:focus { outline: none; border-color: rgba(222,92,51,.9); box-shadow: 0 0 0 3px rgba(222,92,51,.25); }
.gmc__trap { position: absolute; left: -9999px; width: 1px; height: 1px; overflow: hidden; }
.gmc__check { display: flex; align-items: center; gap: 10px; min-height: 44px; font-size: 15px; color: #a2aab1; }
.gmc__check input { width: 22px; height: 22px; accent-color: var(--gm-orange, #c2451e); }
.gmc__bar { position: fixed; left: 0; right: 0; bottom: 0; z-index: 10; display: grid; gap: 6px; padding: 14px 16px calc(28px + env(safe-area-inset-bottom)); background: #f2f4f6; color: #111; }
.gmc__rack { display: flex; align-items: center; justify-content: center; gap: 8px; margin: 0; padding: 8px 0; font-size: 13px; color: #4a545d; }
.gmc__rack::before { content: ""; width: 8px; height: 8px; border-radius: 50%; background: #767f86; }
.gmc__go { display: block; width: 100%; padding: 17px 16px; border: 0; border-radius: 28px; background: var(--gm-orange, #c2451e); color: #fff; font-size: 17px; font-weight: 600; text-align: center; text-decoration: none; cursor: pointer; }
.gmc__go:disabled { opacity: .5; cursor: default; }
.gmc__go:focus-visible, .gmc__add:focus-visible { outline: 3px solid #8db3d9; outline-offset: 2px; }
.gmc__sent { display: grid; gap: 12px; padding: 40px 0; }
.gmc__sent h1 { margin: 0; font-size: 28px; font-weight: 600; }
.gmc__sent p { margin: 0; color: #a2aab1; font-size: 15px; line-height: 1.45; }
@media (min-width: 900px) { .gmc__bar { left: 50%; right: auto; bottom: 24px; width: 440px; transform: translateX(-50%); border-radius: 26px; box-shadow: 0 30px 80px rgba(0,0,0,.55); } }
`;

const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const lbs = (n) => `${Math.round(n).toLocaleString('en-US')} lb`;

// Totals for the list; weight is the cut length, not the billed length.
function cutListTotals(items) {
  const priced = items.filter((i) => !i.freeform);
  const weighed = priced.filter((i) => i.lbft);
  return {
    pieces: priced.reduce((n, i) => n + i.pieces, 0),
    billedFeet: priced.reduce((n, i) => n + i.billedFeet, 0),
    pounds: weighed.reduce((n, i) => n + (i.lbft * i.totalInches) / 12, 0),
    weighedAll: weighed.length === priced.length,
    longestInches: priced.reduce((n, i) => Math.max(n, i.longestInches), 0),
    byMetal: priced.reduce((m, i) => ({ ...m, [i.metalName]: (m[i.metalName] || 0) + i.billedFeet }), {}),
  };
}

// The request as Tim reads it, in Jobber and in email.
function cutListLead(items, who) {
  const t = cutListTotals(items);
  const lines = items.map((i, n) => {
    const head = `${n + 1}. ${i.metalName} ${i.shapeName.toLowerCase()} ${i.label}`;
    const meta = i.freeform ? '(to be priced)' : `${i.pieces} pcs, ${formatFeetInches(i.totalInches)} cut, billed ${i.billedFeet} ft${i.lbft ? `, about ${lbs((i.lbft * i.totalInches) / 12)}` : ''}`;
    return `${head} — ${meta} [${i.rack === 'on_rack' ? 'on rack' : 'order in'}]\n   ${i.text.split(/\r?\n/).join('\n   ')}`;
  });
  const summary = `${items.length} item${items.length === 1 ? '' : 's'}, ${t.pieces} pieces, ${t.billedFeet} ft billed${t.pounds ? `, about ${lbs(t.pounds)}` : ''}`;
  const text = leadText('CUT LIST REQUEST (website)', [
    ['Name', who.name], ['Phone', who.phone], ['Email', who.email], ['Notes', who.notes], ['Email updates', who.newsletter ? 'yes, subscribed' : ''], ['Summary', summary],
  ]) + `\n\n${lines.join('\n\n')}\n\nLongest piece: ${formatFeetInches(t.longestInches)}`;
  return {
    text,
    fields: { type: 'cut_list', name: who.name, phone: who.phone, email: who.email, notes: who.notes, newsletter: who.newsletter ? 'yes' : 'no', summary, details: text, items: JSON.stringify(items) },
  };
}

class GmCutlistPage extends HTMLElement {
  connectedCallback() {
    if (this.form !== undefined) return;
    if (!document.getElementById('gm-cutlist-css')) {
      const style = document.createElement('style');
      style.id = 'gm-cutlist-css';
      style.textContent = PAGE_CSS;
      document.head.append(style);
    }
    this.form = this.querySelector('form');
    if (this.form) this.form.remove();
    if (this.hasAttribute('posted')) clearCutList();
    this.render();
    window.addEventListener(CUTLIST_EVENT, () => this.render());
  }

  render() {
    const buy = this.getAttribute('buy-url') || '/collections/all';
    const inner = document.createElement('div');
    inner.className = 'gmc__inner';
    if (this.hasAttribute('posted')) {
      inner.innerHTML = `<div class="gmc__sent"><h1>Cut list sent</h1>
        <p>${esc(this.getAttribute('sent-text') || "Tim has your list. He'll call to confirm the price and when it's ready for pickup at 1928 Jones Creek Road, Dickson.")}</p>
        <a class="gmc__add" href="${esc(buy)}">Start another cut list</a></div>`;
      this.replaceChildren(inner);
      return;
    }
    const items = loadCutList();
    if (!items.length) {
      inner.innerHTML = `<div class="gmc__head"><h1>Cut list</h1></div>
        <div class="gmc__empty"><p>Your cut list is empty.</p><a class="gmc__go" href="${esc(buy)}">Buy Metal</a></div>`;
      this.replaceChildren(inner);
      return;
    }
    const t = cutListTotals(items);
    const groups = {};
    for (const i of items) (groups[`${i.metalName} · ${i.shapeName}`.toUpperCase()] ||= []).push(i);
    inner.innerHTML = `
      <div class="gmc__head"><h1>Cut list</h1><p>${items.length} item${items.length === 1 ? '' : 's'} · cut to exact length, billed by the whole foot</p></div>
      ${Object.entries(groups).map(([name, list]) => `<p class="gmc__group">${esc(name)}</p>${list.map((i) => `
        <article class="gmc__item">
          <div class="gmc__row"><span class="gmc__label">${esc(i.label)}</span><span class="gmc__feet">${i.freeform ? '' : `${i.billedFeet} ft`}</span></div>
          <p class="gmc__cuts">${esc(i.freeform ? i.text : i.text.split(/\r?\n/).filter(Boolean).join(' · '))}</p>
          <div class="gmc__row"><span class="gmc__meta">${i.freeform ? 'Priced when we call' : `${i.pieces} pcs · ${esc(formatFeetInches(i.totalInches))} cut${i.lbft ? ` · ${lbs((i.lbft * i.totalInches) / 12)}` : ''}`}</span>
            <span class="gmc__actions"><a href="${esc(buy)}?edit=${esc(i.id)}">Edit</a><button type="button" data-remove="${esc(i.id)}" aria-label="Remove ${esc(i.label)}">Remove</button></span></div>
        </article>`).join('')}`).join('')}
      <a class="gmc__add" href="${esc(buy)}">+&nbsp; Add another item</a>
      ${t.pieces ? `<div class="gmc__totals">
        <div><span>${t.pieces} pieces · ${t.billedFeet} ft billed</span><span>${t.pounds ? `≈ ${lbs(t.pounds)}` : ''}</span></div>
        <div><span>Longest piece</span><span>${esc(formatFeetInches(t.longestInches))}</span></div>
        ${Object.entries(t.byMetal).map(([m, ft]) => `<div><span>${esc(m)} (${ft} ft)</span><span>$ —</span></div>`).join('')}
        <div><span>Cut charges (${t.pieces})</span><span>$ —</span></div>
        <div class="gmc__grand"><span>Total</span><span>$ —</span></div>
        <p class="gmc__note">Prices aren't online yet. Send the list and Tim calls with the price and a pickup date.</p>
      </div>` : ''}`;
    if (this.form) {
      this.form.classList.add('gmc__form');
      inner.append(this.form);
      if (!this.form.dataset.wired) {
        this.form.dataset.wired = '1';
        wireLeadForm(this.form, {
          webhook: this.getAttribute('webhook'),
          build: (f) => {
            const v = (n) => (f.querySelector(`[name="contact[${n}]"]`)?.value || '').trim();
            const list = loadCutList();
            if (!list.length) return null;
            const newsletter = Boolean(f.querySelector('[name="contact[newsletter]"]')?.checked);
            if (newsletter && v('email')) {
              const body = new URLSearchParams({ form_type: 'customer', utf8: '✓', 'contact[email]': v('email'), 'contact[tags]': 'newsletter, cut list' });
              fetch(this.getAttribute('subscribe-url') || '/contact', { method: 'POST', body, keepalive: true, credentials: 'same-origin' }).catch(() => {});
            }
            return cutListLead(list, { name: v('name'), phone: v('phone'), email: v('email'), notes: v('notes'), newsletter });
          },
        });
      }
    }
    const bar = document.createElement('div');
    bar.className = 'gmc__bar';
    bar.innerHTML = `<p class="gmc__rack">${esc(this.getAttribute('rack-line') || "Order in · we'll call with a pickup date")}</p>
      <button type="submit" class="gmc__go" form="${esc(this.form?.id || '')}" ${this.form ? '' : 'disabled'}>Send my cut list</button>`;
    this.replaceChildren(inner, bar);
    this.querySelectorAll('[data-remove]').forEach((b) => b.onclick = () => removeItem(b.dataset.remove));
  }
}

if (!customElements.get('gm-cutlist-page')) customElements.define('gm-cutlist-page', GmCutlistPage);

return { cutListTotals, cutListLead };
})();
const __gm_drawer = (() => {
// <gm-drawer>: the menu from the Figma board (P0). The header stays in place while the
// drawer unrolls beneath it; the motion itself is CSS in sections/gm-header.liquid, keyed
// off header[data-menu="open"] and gm-drawer[data-open]. The menu button toggles; Escape
// and any link close it. Also keeps every [data-cutlist-count] badge in
// step with the cut list, which lives on the phone rather than in Shopify's cart.

const { loadCutList, CUTLIST_EVENT } = __gm_cutlist_store;

class GmDrawer extends HTMLElement {
  connectedCallback() {
    if (this.wired) return;
    this.wired = true;
    this.header = document.getElementById(this.dataset.header || 'gm-header');
    this.toggles = [...document.querySelectorAll(`[data-drawer-open="${this.id}"]`)];
    this.toggles.forEach((b) => b.addEventListener('click', () => (this.isOpen ? this.close() : this.open())));
    document.querySelectorAll('[data-drawer-close]').forEach((b) => b.addEventListener('click', () => this.close()));
    this.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => this.close(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.isOpen) this.close(); });
    matchMedia('(min-width: 990px)').addEventListener('change', (e) => { if (e.matches) this.close(false); });

    const count = () => {
      const n = loadCutList().length;
      document.querySelectorAll('[data-cutlist-count]').forEach((el) => { el.textContent = n; el.hidden = !n; });
    };
    count();
    window.addEventListener(CUTLIST_EVENT, count);
    window.addEventListener('storage', count);
  }

  get isOpen() { return this.hasAttribute('data-open'); }

  open() {
    if (this.header) {
      this.style.setProperty('--gm-header-h', `${this.header.querySelector('.gm-header__row')?.offsetHeight || 56}px`);
      this.header.dataset.menu = 'open';
    }
    this.inert = false;
    this.setAttribute('data-open', '');
    document.documentElement.style.overflow = 'hidden';
    this.toggles.forEach((b) => { b.setAttribute('aria-expanded', 'true'); b.setAttribute('aria-label', 'Close menu'); });
    setTimeout(() => this.querySelector('a')?.focus({ preventScroll: true }), 200);
  }

  close(returnFocus = true) {
    if (!this.isOpen) return;
    this.removeAttribute('data-open');
    this.inert = true;
    if (this.header) {
      delete this.header.dataset.menu;
    }
    document.documentElement.style.overflow = '';
    this.toggles.forEach((b) => { b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-label', 'Menu'); });
    if (returnFocus) this.toggles[0]?.focus({ preventScroll: true });
  }
}

if (!customElements.get('gm-drawer')) customElements.define('gm-drawer', GmDrawer);

return {  };
})();
